import {
	SET_LISTING_DATA,
	SET_ACTION_CARD_DATA,
	SET_SEARCH_DATA,
	UPDATE_PRODUCT_PRICE,
	UPDATE_PRODUCT_SELLING_PRICE,
	DELETE_PRODUCT,
	EDIT_PRODUCT,
	EDIT_ENRICH_PRODUCT,
	INIT_ADD_PRODUCT,
	UPDATE_EDIT_PRODUCT_DETAIL,
	HIDE_PRODUCT_EDIT_SLIDER,
	HIDE_ITEM_SEARCH_SLIDER,
	SHOW_PRODUCT_EDIT_SLIDER,
	SHOW_ITEM_SEARCH_SLIDER,
	SHOW_NOT_FOUND_MODAL,
	HIDE_NOT_FOUND_MODAL,
	RESET_PRODUCT_DATA,
	SETPSVINFODATA,
	UPDATE_PRODUCT_IMAGE,
	SET_SESSION,
	SAVE_ADD_EDIT_PRODUCT,
	SAVE_REJECTED_VIA_AUDIT,
	SET_APPROVAL_PENDING,
	SET_PRODUCT_CONFLICT,
	SET_DELETION_PENDING,
	SET_BRAND_PROD_SELECTION,
	SET_TAB_STATUS,
	EMPTY_SEARCH_DATA,
	TOGGLE_EDIT_IMAGE_OPTIONS,
	DELETE_PRODUCT_IMAGE,
	SET_CURRENT_EDIT_PAGE,
	PRODUCTSCORE,
	PRODUCT_UNDER_EDIT,
	IS_PRODUCT_UPDATED,
	RESET_LISTING_DATA,
	RESET_RESULT_DATA,
	LISTING_FILTER,
	UPDATE_IMAGES_BEING_UPLOADED,
	GET_BIZ,
	UPDATE_BIZ,
	TOGGLE_PRODUCT_VISIBILITY,
	UPDATE_PRODUCT_VIDEO,
	SET_PRODUCT_SPECIFICATION,
	UNLINK_VIDEO,
	DISCARD_ADD_PRODUCT_MEDIA,
	SET_ATTACHMENT_DATA,
	DELETE_ATTACHMENT_FILE,
	TOGGLE_EDIT_DISPLAYNAME_MODAL,
	RENAME_PRODUCT_ATTACHMENT,
	VIEW_FILE_DETAILS_SLIDER,
	TOGGLE_FILE_PROGRESS_BAR,
	CANCEL_PENDING_FILES,
	MARK_PREVIOUSLY_UPLOADED_FILES,
	SET_AUDIT_OBJECT,
	RESTORE_PRODUCT_DATA,
	TOGGLE_CONFIRM_DELETE,
	TOGGLE_CONFIRM_APPROVE,
	TOGGLE_TAB,
	REDIRECTED_FROM,
	TOGGLE_INFO_BOX,
	TOGGLE_ADD_PRODUCT_SLIDER,
	TOGGLE_ADD_EDIT_BUTTON_ANIMATION,
	FROM_EDIT_PRODUCT_SLIDER,
	TOGGLE_SEARCH_SLIDER,
	TOGGLE_ACTION_CARD_SLIDER,
	TOGGLE_SUPPORT_SLIDER,
	ACTION_CARD_FILTER,
	RELOAD_ACTION_CARD_SLIDER,
	FILE_ATTACHMENT_PERMISSION,
	RESET_FILE_ATTACHMENT_DATA,
	SET_VENDOR_IMAGES,
	UPLOAD_MULTIPLE_IMAGES,
	SET_PRODUCT_SLIDER_DATA,
	SET_OBJECTIONAL_PENDING,
	SET_BRAND_PENDING,
	SET_VENDOR_OBJECTIONABLE_PRODUCTS,
	SET_GENERIC_DELETION_PENDING,
	INITIAL_COUNTRY_CODE,
	SET_SELECTED_CATEGORY,
	SET_AUDIT_PENDING,
	SET_REJECTED_PRODUCTS,
	SET_BRAND_SUGGESTION,
	SET_QUEUE_TYPE,
	SET_HYBRID_DATA,
	UPDATE_SPECIFICATION_DATA,
	SET_EDIT_VARIANT_DATA,
	SET_SMART_FILL_DATA,
	SET_AUDITOR_BRANDED_LOG,
	SET_SEARCH_BY_DOC_ID,
	SET_VIA_SUGGESTED,
	SET_FROM_SELLER,
	SET_SUGGESTED_VIA_SEARCH,
	SET_SHOULD_RETAIN,
	UPDATE_FIXED_SPECS,
	SET_PREVIOUS_TAB_INDEX,
	SET_APP_CAT_COV_USER,
	DELETE_IMAGE_FROM_ADD_EDIT,
	UPLOAD_IMAGE_FROM_ADD_EDIT,
	UNLINK_VIDEO_TOP_RODUCT_FROM_ADD_EDIT,
	REMOVE_VIDEO_FROM_ADD_EDIT,
	UPDATE_PRODUCT_VIDEO_FROM_ADD_EDIT,
	ADD_VIDEO_TO_LIBRARY,
	LINK_VIDEO_TO_PRODUCT_FROM_ADD_EDIT,
	TOGGLE_BROCHURE_UPLOADHISTORY_SLIDER,
	TOGGLE_BROCHURE_EDITNAME_DIALOG,
	SET_BROCHURE_DATA,
	BROCHURE_TOTAL_FILES_UPLOAD,
	BROCHURE_TOTAL_FILES_ERROR,
	BROCHURE_SUCCESS_FILE_UPLOAD,
	BROCHURE_FILES_RESET_DATA,
	BROCHURE_TEMP_ACTIVE_TAB,
	BROCHURE_LISTING_DATA,
	BROCHURE_LISTING_COUNT,
	TOGGLE_PRODUCT_CARD_SLIDER,
	PRICE_CARD_DATA_FETCHED,
	PENDING_TABS,
	SHOW_HIDE_EDIT_OPTION,
	PAUSE_APPROVAL_REDIRECT,
	TOGGLE_OUTDATED_PRODUCT_CARD_SLIDER,
	OUTDATED_PRICE_CARD_DATA_FETCHED,
	TOGGLE_CATEGORY_MISSING_CARD_SLIDER,
	CATEGORY_MISSING_DATA_FETCHED,
	TOGGLE_CATEGORY_MISSING_CARD_SLIDER_PERSIST,
	DELETE_VIDEO_URL_ID_ALL_PRODUCTS,
	UPDATE_DESC_TYPE,
	TOGGLE_AI_CREATION_MODAL,
} from './types';
import axios from 'axios';
import queryString from 'querystring';
import config from '../../config/config';
import { formatVendorData, identifyAuditFlow, formatProdDesc, objectionalKeyHandling, notifyCatalogueCreated, getJdMartParams, checkForTrailingZeroes, getMatchedUOM, Regex, getDeviceType } from '../utills';
import { formatVariantData, formatVariantForObjection } from './variants'
export const setDeviceData = payload => ({
	type: 'SET_DEVICE_DATA',
	payload
});
import {
	getImagePath,
	updateProductMediaService,
	mediaApiCancelTokens
} from '../common/productImageUtils';
import { updateVideoInLibrary, linkUnlinkVideoRequest, selectVideo, getVideoLibraryData } from './videoLibrary';
import { setSelectedGalleryImages } from './photosGallery';
import { getAllSpecificationData } from '../pages/add-edit-product/c-specification-slider/customActions';
import { updateBrandManufactureDetails, updateSpecificationData } from '../actions/productSpecification';
import { getStore } from '../../store/createStore';
import { showHideLoader } from '.';
import { uploadImageFromLink } from './upload-options';
import Axios from 'axios';
const apiDomain = config.apiDomains[0];
const CancelToken = axios.CancelToken;
let sourceForSearch = null;
let currentRequestId = 0;
let mapTabsWithCount = {
	objectionable: 'objectionableTotalCount',
	auditPending: 'auditPendingCount',
	approvalPending: 'approvalPendingCount',
	rejected: 'rejectedCount',
	documentPending: 'documentPendingCount'
}
const formatMediaUrl = (imageUrl, videoUrl, isVideoEnabled, isTemplate,labelImages) => {
	let videoUrlObj = {};
	let labelImagesArr = labelImages?labelImages.split(','):[];
	try {
		videoUrlObj = JSON.parse(videoUrl || '{}');
	} catch (e) {
		console.log(e);
	}
	let imageUrlArr = [];
	(imageUrl || '').split(',').forEach(cur => {
		if (cur) {
			imageUrlArr.push({
				imgURL: cur,
				actualPath: getImagePath(cur, isTemplate),
				uploaded: true,
				isLabelProof: labelImagesArr.includes(cur)
			})
		}
	});
	return imageUrlArr;
};

export const getSearchToken = (options = {}) => {
	let { token } = options;
	let params = queryString.parse(window.location.search);
	if (params.actualToken) {
		return params.actualToken;
	} else {
		return token;
	}
};

export const toggleProdConflict = (payload) => ({
	type: 'TOGGLE_PROD_CONFLICT',
	payload
})
const suggestAutosuggest = (dataArr = []) => {
	let result = [];
	if(dataArr.length){
		dataArr.map(cur => {
			result.push({
				imageUrl: cur.image || cur.imgpath,
				productName: cur.name || cur.productName,
				priceObj: {singlePrice: cur.price || cur.mrp, isSinglePrice: true},
				isSellOnline: true,
				productId: cur.id
			})
		})
	}
	return result;
}

export const resetListingData =()=> async(dispatch, getState) => {
	dispatch({
		type: RESET_RESULT_DATA
	});
}
export const filterQuery =(payload)=> async(dispatch, getState) =>  {
	dispatch({
		type : LISTING_FILTER,
		payload : payload
	})
}

export const setPendingTabs =(payload)=> async(dispatch, getState) =>  {
	dispatch({
		type : PENDING_TABS,
		payload : payload
	})
}
export const setPauseApprovalRedirect =(payload)=> async(dispatch, getState) =>  {
	dispatch({
		type : PAUSE_APPROVAL_REDIRECT,
		payload : payload
	})
}



export const getListingData = ({
	pageNo = 1,
	filterObj = {},
	isSearch,
	isFilter,
	filterStr,
	cardName,
	count,
	supplierId,
	searchText,
	tabKey,
	finalPageNo,
	keepAddProd,
	orderBy = "",
	isSelectProdSlider,
	cb,
	isPhoto,
	lastPid,
	isReadOnly,
	brochureCb,
	fromImageSlider = false
}) => async (dispatch, getState) => {
	const state = getState();
	const isVideoEnabled = state.session.isVideoEnabled;
	const token = state.session.token;
	const source = state.session.source;
	const videos = state.videoLibrary.videos;
	const loggedUser = state.session.user.loggedUser
	const newProfile = state.session.newProfile;
	const viaOmni = state?.session?.viaOmni ? state.session.viaOmni : null;
	let listingData = {};
	let res;
	const requestId = ++currentRequestId;
	await getVideoLibraryData()(dispatch, getState);
	if (!isSearch && !isFilter) {
		console.log("API CALL TRACE", new Error().stack);
		let strUrl = `${apiDomain}/marketplace/static/php/web/b2bWebsite.php?action=listing&token=${token}`;
		const flowCheck = identifyAuditFlow({ checkType: true });
		let { queueType = ''} = identifyAuditFlow({ query: true });
		let auditApi = false;
		if (flowCheck.searchAudit) {
			auditApi = true;
			strUrl = `${apiDomain}/marketplace/static/php/web/b2bWebsite.php${window.location.search}&action=searchAuditProductForMarketplace`;
			if(queueType || state.products.queueType){
				strUrl += `&queueType=${queueType || state.products.queueType}`;
			}
		}
		if (finalPageNo) {
			strUrl += '&finalPageNo=' + finalPageNo
		} else {
			strUrl += '&pageNo=' + pageNo;
		}
		if (orderBy === "image" && isSelectProdSlider) {
			strUrl += '&orderByImage=true&tab=searchProductForImage&fromTab='+tabKey;
		}
		if (tabKey && tabKey != 'brand') {
			strUrl += ('&tab=' + tabKey);
		}
		else if(tabKey == 'brand'){
			strUrl = `/vendorapis/products/product/suggestedProducts?action=getSearchResults&limit=25&supplierId=${supplierId}&page=${pageNo}&profileType=${newProfile}`
		}
		if(tabKey == 'productConflict'){
			strUrl = `/vendorapis/products/barcode/getBarcodeConflict?token=${token}`;
		}
		if (viaOmni) {
			strUrl += `&viaOmni=1`;
			if(tabKey == 'omniService') {
				strUrl += `&pType=2&visibility=allProducts`;
			}
		}

		Object.keys(filterObj).map(key => {
			if(key=="brands"){
				strUrl +="&pType=1"
			}
			if (flowCheck.searchAudit) {
				let temp = filterObj[key];
				strUrl += `&${key}=${temp.join(",")}`;
			} else if(key == 'brands'){
				strUrl += `&${key}=${filterObj[key]?.toString()}`;
			}else {
				strUrl += `&${key}=${filterObj[key][0]}`;
			}
		});
		sourceForSearch && sourceForSearch.cancel('Operation canceled by the user.');
		sourceForSearch = CancelToken.source();
		try {
				res = await axios.get(strUrl, {
					cancelToken: sourceForSearch.token
			});
		} catch (e) {
			return e;
		}
		if(viaOmni && requestId != currentRequestId) {
			return;
		}
		if (tabKey && mapTabsWithCount[tabKey] && ((res.data[mapTabsWithCount[tabKey]] == 0 || (res.data?.data && res.data.data[mapTabsWithCount[tabKey]] == 0) || !res.data.data.productData?.length))) {
			dispatch(setTabStatus({ tabKey: undefined }));
			dispatch(setPreviousTabIndex({tabIndex: 0}));
			dispatch(getListingData({
				pageNo: 1,
				supplierId: state.session.supplierId,
				tabKey: undefined
			}));
			cb && cb();
			return;
		}

		if (auditApi && res.data && res.data.data && res.data.data.productData) {
			res.data.data.productData.forEach((item) => {
				item.videoUrlIds = [];
			});
		}
		if(tabKey == 'brand'){
			res.data = {data: {...res.data}}
		}
		if (tabKey == 'productConflict' && res.data && res.data.data && res.data.data.productData) {
			res.data.data.productData.forEach((item) => {
				item.productId = item.barcodeConflictId;
			});
		}
		listingData = {
			productData: [],//will be overriden by res.data.data
			...res.data.data,
			currentPage: pageNo,
			isSpecialContractJd: res.data.isSpecialContractJd,
			filterObj,
			isReset: !!finalPageNo,
			videos,
			keepAddProd: keepAddProd,
			tabKey: tabKey,
		};
		cb && cb(!fromImageSlider ? listingData : null);
		if ((res.data.status == 0 || (auditApi && res.data.status == 2)) && source != "webstore") {
			dispatch({
				type: SET_SESSION,
				payload: {
					isUnauthorized: true
				}
			})
		}
	}else if (isFilter && !isSearch){
		let parmas = count > 25 ? `&pageSize=${count}` : `&page=${pageNo}`
		let filterUrl = `/marketplace/static/php/web/b2bWebsite.php?action=listing&token=${token}${filterStr}${parmas}`
		const res = await axios.get(filterUrl)
		if (res.status){
			res.data.data.productData.map(cur => {
				cur.imageUrlArr = formatMediaUrl(cur.imageUrl, cur.videoUrl, isVideoEnabled, ((cur.isTempProd || cur.isTemplate) && cur?.showUpload !==1));
			});

			let listingData = {
			productData: [],//will be overriden by res.data.data
			...res.data.data,
			currentPage: pageNo,
			cardName:	cardName
		};
		// cb && cb(res.data);
		dispatch({
			type: SET_ACTION_CARD_DATA,
			payload: {...listingData,filterQuery:filterStr,cardName:cardName }
		});
		}
	}else {
		sourceForSearch &&
			sourceForSearch.cancel('Operation canceled by the user.');
		sourceForSearch = CancelToken.source();
		let isAuditSearch = '';
		const docIdCheck = identifyAuditFlow({ query: true });
		if (docIdCheck.searchBy == 'docId') {
			isAuditSearch = "&isAuditSearch=true";
		}
		let b2bUrl = `${apiDomain}/marketplace/static/php/web/b2bWebsite.php?action=searchDc&token=${getSearchToken({ token })}&pageNo=1&searchStr=${searchText}${isAuditSearch}`;
		// let vendorUrl = `${apiDomain}/marketplace/products/services/listing.service?reviewtate=allProducts&status=ACTIVE&supplierId=${supplierId}&company=&pageNumber=1&visibility=allProducts&searchKeywords=${searchText}`
		let strUrl = b2bUrl;
		if(tabKey == 'brand' && searchText.length && !isPhoto){
			if(isNaN(searchText)){
				// strUrl = `/vendorapis/products/product/suggestedProducts?action=getSearchResults&limit=25&supplierId=${supplierId}&srch_term=${searchText}&page=${pageNo}`
				strUrl = `/vendorapis/products/product/fetchTemplateProductsBySearchTerm?limit=25&page=${pageNo}&type=1&token=${token}&srchterm=${searchText}&profileType=${newProfile}`;
			}
			else{
				strUrl = `/vendorapis/products/product/fetchTemplateProductById?limit=25&page=${pageNo}&type=1&token=${token}&barcode=${searchText}&newProfile=${state.session.newProfile}`;
			}
		}
		if(isPhoto){
			strUrl += `&allotImage=1`;
		}
		try {
			res = await axios.get(strUrl, {
				cancelToken: sourceForSearch.token
			});
		} catch (e) {
			return;
		}
		sourceForSearch = null;
		if(tabKey == 'brand' && searchText.length && !isPhoto){
			res.data = {data: {productData: suggestAutosuggest(res.data.length ?res.data : res.data?.data)}};
		}
		listingData = source == 'webstore' ? {
			searchQuery: searchText,
			productData: formatVendorData(res.data.page.results)
		} : {
			productData: [],
			...res.data.data,
			currentPage: pageNo,
			searchQuery: searchText,
			videos
		};
	}
	let searchByDocId = false;
	const docIdCheck = identifyAuditFlow({ query: true });
	const flowCheck = identifyAuditFlow({ checkType: true });
	if (docIdCheck.searchBy == 'docId') {
		searchByDocId = true;
	}
	if (flowCheck.searchAudit && searchByDocId && res.data) {
		listingData.objectionableTotalCount = res.data.objectionableTotalCount
	}

	let productList = listingData.productData || [];
	if (searchByDocId && res.data && res.data.headerData) {
		listingData.headerData = res.data.headerData;
	}
	productList.map(cur => {
		if (['0', '0.0', '0.00'].indexOf(cur.sellingPrice) > -1) {
			cur.sellingPrice = '';
		}
		cur.imageUrlArr = formatMediaUrl(cur.imageUrl, cur.videoUrl, isVideoEnabled, ((cur.isTempProd || cur.isTemplate) && cur?.showUpload !==1));
	});
	let type = SET_LISTING_DATA;
	if (isSearch) {
		type = SET_SEARCH_DATA
	} else if (isSelectProdSlider) {
		type = SET_PRODUCT_SLIDER_DATA
	}
	cb && cb(listingData);
	if(!isFilter){
		dispatch({
			type: type,
			payload: {...listingData,isReadOnly: isReadOnly?isReadOnly:state.session.isReadOnly,loggedUser,showShimmer: false,gotResponse: true}
		});
	}
	if(tabKey == 'auditPending'){
		return listingData;
	}
};

export const productScoreUpdate = payload =>  (dispatch, getState) => {
	const url = "/marketplace/dc-common/scoreDetail.ns"
    const queryParams = `pid=${payload.id}&docid=${payload.docId}`
    axios.get(`${url}?${queryParams}`)
	.then(rsp => {
		const res = rsp.data
        if (res?.error == 0) {
			payload.score =  res.results?.final_weight?.final_weight?.calc || 0
			dispatch({
				type : PRODUCTSCORE,
				payload
			})	
		}
	})
	.catch(err=>{
		console.log('err=>',err);
	})
}

export const productUnderEdit = payload => ({
	type: PRODUCT_UNDER_EDIT,
	payload
});


// export const productUnderEdit = (productObj) => dispatch => {
//   dispatch({
//     type: UPDATE_PRODUCT_PRICE,
//     payload: {
//       sellingPrice: price,
//       variantId: variantId
//     }
//   });
// }

export const addRemoveSpecVariant = payload => (dispatch,getState) => {
	const state = getState();
	let convertedData = [...state.productSpecification.editablePuvSpecAttributes];
	let s_mandFieldCount = 0;
	let re_mandFieldCount = 0;
	let listToReturn = [];
	if(payload.remove) {
		listToReturn = convertedData.filter(el => state.variants.variantSpec.includes(el.s_dnm));
		convertedData = convertedData.filter(el => !state.variants.variantSpec.includes(el.s_dnm));
	}else {
		convertedData = convertedData.concat(payload.data);
	}
	convertedData.map(cur => {
		if(!['brand','manufacturer','manufactured_details','country_of_origin','importer','importers_detail','price','packaging_length','packaging_weight','packaging_height','packaging_width','expiry_date'].includes(cur.s_nm.toLowerCase())) {
			if(Number(cur.s_mandatory) == 1){
				s_mandFieldCount++;
			}
			if(Number(cur.s_re_mandatory) == 1){
				re_mandFieldCount++;
			}
		}
	});
	dispatch(updateSpecificationData({
		initPuvSpecAttributes: convertedData,
		editablePuvSpecAttributes: convertedData,
		s_mandatoryPresent: s_mandFieldCount,
		re_mandatoryPresent: re_mandFieldCount,
		installationFlag: state.productSpecification.installationFlag,
		expiryFlag: state.productSpecification.expiryFlag,
		lbl_img_mandatory: state.productSpecification.lbl_img_mandatory
	}));
	return listToReturn;
}

export const updateProductPrice = productObj => async dispatch => {
	let { editFlag, price, productId, cb, cbError, token, uom, priceObj, isSellOnline, barcode = '' } = productObj;
	let jdMartParams = getJdMartParams();
	let sellOnlineAppend = '';
	if (isSellOnline) {
		sellOnlineAppend = `&quantity=0&sellingPrice=${priceObj.sellingPrice}&mrp=${priceObj.mrp}&barcode=${barcode ? barcode : null}&isSellOnline=${isSellOnline}`;
	}

	const res = await axios.post(
		apiDomain +
		'/marketplace/static/php/web/b2bWebsite.php?action=updatePrice', queryString.stringify({
			status: editFlag,
			priceObj: JSON.stringify(priceObj),
			productId,
			token,
			unitOfMeasurement: uom,
			sourceId: (jdMartParams.sourceId ? jdMartParams.sourceId : ''),
			sellOnlineAppend
		}));
	if (res.data.status == 1) {
		cb && cb();
	}
	if (res.data.status==3) {
		cbError && cbError(res.data?.priceRange?.minPrice, res.data?.priceRange?.maxPrice, res.data?.msg)
	}else {
		dispatch({
			type: UPDATE_PRODUCT_PRICE,
			payload: {
				//sellingPrice: price,
				priceObj: priceObj,
				productId: productId
			}
		});
	}
};

export const deleteProduct = (productIds, cb, productId, options = {}) => async (dispatch, getState) => {
	const state = getState();
	const token = state.session.token;
	let res;
	const { generic_p_id, objectional_ids = '' } = options;
	
	let jdMartParams = getJdMartParams();
	if (state.session.source == 'webstore') {
		let formData = new FormData();
		formData.append("productIds", productId);
		formData.append("status", 'IN_RECYCLEBIN');
		formData.append("isSelectAll", false);
		formData.append("moduleType", 'product');
		res = await axios.post(apiDomain + `/marketplace/products/ajax/services/changeStatusForAdmin.service`, formData);
	} else {
		if (objectional_ids) {
			dispatch(deleteObjectionableProduct({id: objectional_ids, refreshList: false}));
		}
		if (productIds || generic_p_id) {
			res = await axios.get(
				apiDomain +
				`/marketplace/static/php/web/b2bWebsite.php?&action=deleteProduct&token=${token}&productId=${productIds}&generic_p_id=${generic_p_id ? encodeURIComponent(generic_p_id) : ''}&sourceId=${jdMartParams.sourceId ? jdMartParams.sourceId : ''}`
			);
		}
		
	}
	if (!(productIds || generic_p_id) || res.data.status == 1 || (res.status == 200 && state.session.source == "webstore")) {
		cb && cb();
		if (state.session.source != "webstore") {
			/** As per Hitesh Adding this here */
			if (productIds) {
				dispatch({
					type: DELETE_PRODUCT,
					payload: {
						productId: productIds
					}
				});	
			}
			dispatch(getListingData({
				filterObj: state.products.listing.filterObj,
				isSearch: options.isSearch?options.isSearch:false,
				searchText: options.searchText?options.searchText:'',
				supplierId: state.session.supplierId,
				finalPageNo: state.products.listing.currentPage,
				tabKey: state.products.tabKey,
				cb: options.cb?options.cb:''
			}))
		}
	}
};

export const objectionableTakeLive = (id, options) => async (dispatch, getState) => {
	const state = getState();
	const token = state.session.token;
	let jdMartParams = getJdMartParams();
	let res = await axios.get(
		apiDomain +
		`/marketplace/static/php/web/b2bWebsite.php?action=requestToTakeLive&token=${encodeURIComponent(token)}&id=${encodeURIComponent(id)}&sourceId=${jdMartParams.sourceId ? jdMartParams.sourceId : ''}`
	);
	if (res.data.status == 1) {
		options.cb && options.cb();
		dispatch(getListingData({
			filterObj: state.products.listing.filterObj,
			isSearch: false,
			supplierId: state.session.supplierId,
			finalPageNo: state.products.listing.currentPage,
			tabKey: state.products.tabKey
		}))
	}
}

export const updateBrandedProduct = (options) => async (dispatch, getState) => {
	const state = getState();
	const token = state.session.token;
	let data = options.productData;
	let url = apiDomain + `/marketplace/static/php/web/b2bWebsite.php`;
	let jdMartParams = getJdMartParams();
	url += `?&sourceId=${jdMartParams.sourceId ? jdMartParams.sourceId : ''}`;
	data.action = "updateBrandedProducts";
	data.token = token;
	data.isBrandedProd = 1;
	data.priceObj = JSON.stringify(data.priceObj);
	data = queryString.stringify(data);
	let res = await axios.post(url, data);
	if (res.data.status == 1) {
		options.cb && options.cb();
		let tabKey = '';
		if (options.isEditSave) {
			tabKey = 'brand';
			dispatch({
				type: SAVE_ADD_EDIT_PRODUCT,
				payload: {
					...data
				}
			});
			dispatch(setTabStatus({ tabKey: tabKey ? tabKey : undefined }));
		}
		dispatch(getListingData({
			filterObj: state.products.listing.filterObj,
			isSearch: false,
			supplierId: state.session.supplierId,
			finalPageNo: state.products.listing.currentPage,
			tabKey: state.products.tabKey
		}))
	} else {
		console.log("failed");
	}
}

export const updateMultiBrandProd = (options = {}) => async (dispatch, getState) => {
	const { token = '', variantIds = [], activate = 0, cb } = options;
	const state = getState();
	let url = `/marketplace/static/php/web/b2bWebsite.php?action=updateBrandedProductsActiveState`;
	let data = {
		action: 'updateBrandedProductsActiveState',
		token,
		variantIds: variantIds.join(','),
		active: activate
	};
	data = queryString.stringify(data);
	axios.post(url, data).then((res) => {
		if (res.data.status == 1) {
			cb && cb(res.data);
			const tabKey = 'brand';
			dispatch(setTabStatus({ tabKey: tabKey ? tabKey : undefined }));
			dispatch(getListingData({
				filterObj: state.products.listing.filterObj,
				isSearch: false,
				supplierId: state.session.supplierId,
				finalPageNo: state.products.listing.currentPage,
				tabKey: tabKey
			}))
		}
	});
};

export const deleteObjectionableProduct = (options = {}) => async (dispatch, getState) => {
	const { id, refreshList = true } = options;
	const state = getState();
	const token = state.session.token;
	let jdMartParams = getJdMartParams();
	let res = await axios.get(
		apiDomain +
		`/marketplace/static/php/web/b2bWebsite.php?action=deleteObjectionableProduct&token=${encodeURIComponent(token)}&id=${encodeURIComponent(id)}&sourceId=${jdMartParams.sourceId ? jdMartParams.sourceId : ''}`
	);
	if (res.data.status == 1 && refreshList) {
		dispatch(getListingData({
			filterObj: state.products.listing.filterObj,
			isSearch: false,
			supplierId: state.session.supplierId,
			finalPageNo: state.products.listing.currentPage,
			tabKey: state.products.tabKey
		}))
	}
}

export const updateProductsWithSmartFill = ({
	cb,
	complianceSpecsFieldsArr = [],
	catId = '',
	brand = ''
}) => async (dispatch, getState) => {
	const state = getState();
	let postData = {
		supplierId : state.session.supplierId,
		category: catId,
		brand,
		specification: JSON.stringify(complianceSpecsFieldsArr)
	}
	postData = queryString.stringify(postData);
	let complianceData = await axios.post(
		`/vendorapis/products/ajax/smartFill`,
		postData
	);
	if(complianceData.errors?.code == 0 || complianceData.data == 'Specifications Updated Successfully'){
		cb && cb();
	}else{
		cb && cb();
	}
};

export const getProductSmartFillSpec = ({
	psv_node_id,
	brand,
	custom
}) => async (dispatch, getState) => {
	const state = getState();
	const supplierId = state.session.supplierId;
	const docid = state.session.docId;
	let postData = {
		supplierId,
		docid,
		psv_node_id,
		brand,
		type: custom ? 'custom' : 'branded'
	}
	postData = queryString.stringify(postData);
	let url = `/vendorapis/products/ajax/getSmartFillProductSpec`;
	axios.post(url,postData).then(({ data }) => {
		if(data && data.data && Object.keys(data.data)?.length){
			axios.get('/vendorapis/products/product/getSpecInfo?spec_names=manufacturer,country_of_origin,importers_detail,importer,manufactured_details,brand&action=getSpecInfo').then(res => {
				let finalData = {};
				let compliance = state.products?.editProduct?.compliance;
				let isIndia = compliance?.country_of_origin?.toLowerCase() == 'india';
				if(!custom && compliance){
					Object.keys(compliance).length && Object.keys(compliance).forEach((cur)=>{
						if(cur == 'tax_rate' || cur == 'hsn' || cur == 'product_warranty'){
							return;
						}
						if(compliance[cur]){
							finalData[cur] = compliance[cur];
						}else{
							if(isIndia && (cur == 'importer' || cur == 'importers_detail')){
								finalData[cur] = '';
							}else{
								finalData[cur] = data?.data[cur];
							}
						}
					});
				}
				dispatch(setHybridData({data : custom ? data.data : finalData, sidData: res.data.data,smart: true,branded:!custom }));
			})
		}
	});
};

export const hideProductEditSlider = () => {
	return {
		type: HIDE_PRODUCT_EDIT_SLIDER
	}
}
export const hideItemSearch = () => {
	return {
		type: HIDE_ITEM_SEARCH_SLIDER
	}
}
export const showItemSearchSlider = (payload) => {
	return {
		type: SHOW_ITEM_SEARCH_SLIDER,
		payload
	}
}
export const showNotFoundModal = (payload) => {
	return {
		type: SHOW_NOT_FOUND_MODAL,
		payload
	}
}
export const hideNotFoundModal = () => {
	return {
		type: HIDE_NOT_FOUND_MODAL
	}
}
export const setSelectedType=({selectedCategoryType})=>async (dispatch, getState) =>{
	dispatch({
		type: SET_SELECTED_CATEGORY,
		payload: { data: selectedCategoryType }
	});
}

export const addUpdateFixedSpecs = ({dataToAdd}) => async (dispatch,getState) => {
	const state = getState();
	let fixedSpecs = state.brandManufacturer.fixedSpecs;
	let specsList = fixedSpecs?.size ? fixedSpecs : new Set();
	Array.isArray(dataToAdd) && dataToAdd?.map(cur => {
		specsList.add(cur);
	})
	dispatch({
		type: UPDATE_FIXED_SPECS,
		payload: specsList
	})
}

export const getEnrichData = ({productBankId, cb}) => async (dispatch, getState) => {

	const state = getState();
	const res = await axios.get(
		apiDomain +
		`/vendorapis/contractor/contractor/getProductBankData?productId=${productBankId}`
	);
	let queueType = 'brandedQueue';
	if(queueType){
		dispatch({
			type: SET_QUEUE_TYPE,
			payload: {
				queueType
			}
		});
	}
	const productData = res?.data?.data;
	let isError = false;
	if ( !productData ||
		(
			(!productData.compliance || Object.keys(productData.compliance).length == 0) &&
			(!productData.details || Object.keys(productData.details).length == 0) &&
			(!productData.images || productData.images.length == 0) &&
			(!productData.label_images || productData.label_images.length == 0) &&
			(!productData.specification || productData.specification.length == 0) &&
			(!productData.videos || productData.videos.length == 0)
		)
	 ) {
		 isError = true;
	}
	if (!isError) { //need to put condition .status==1 once backend provide it
		const bizSuggestion = {};

		productData.isTemplate = queueType=='brandedQueue' ? true : false;


		let imgUrls = '';
		productData.images.map((curImage, index) => {
			imgUrls += (index>0 ? ',' : '')+curImage.img;
		});

		productData.imageUrlArr = formatMediaUrl(imgUrls, '','', productData.isTemplate, '');

		let labelImageUrl = [];
		let labelFrontImageUrl = [];
		productData.label_images.map((curImage, index) => {
			if (curImage?.img) {
				if (Number(curImage?.view_type)==1) {
					labelFrontImageUrl[0] = getImagePath(curImage.img, productData.isTemplate);
				} else if (Number(curImage?.view_type)==2) {
					labelImageUrl[0] = getImagePath(curImage.img, productData.isTemplate);
				}
			}
		});
		productData.labelImageUrl = labelImageUrl;
		productData.labelFrontImageUrl = labelFrontImageUrl;
		productData.lbl_img_mandatory = 0;
		if (productData.labelImageUrl.length == 0 || productData.labelFrontImageUrl.length == 0) {
			productData.lbl_img_mandatory = 1;
		}
		productData.productId = productData.compliance.productId;
		productData.productName = productData.compliance.productName;
		productData.barcode = productData.compliance.barcode;
		productData.description = productData.details.description;
		productData.isBrandedProd = productData.isTemplate;
		productData.leafId = productData.compliance.psv_node_id	;
		productData.bid = productData.compliance.brand_id;
		productData.videoUrlIds = [];
		if (!productData?.referenceLinks) {
			productData.referenceLinks = [{link: '', valid: true}];
		}

		if(productData.compliance) {
			let complianceCount = 0;
			Object.keys(productData.compliance).map(key => {
                if(!['price','packaging_width','packaging_height','packaging_length','packaging_weight','expiry_date','brand'].includes(key.toLowerCase())){
                  complianceCount++;
                }
            })
			productData.hasCompliance = complianceCount;
		}
		if(productData.videos?.length){
			const video = productData.videos[0];
			const videoId = Date.now();
			const videoData = {
				videoId,
				videodata:{
					actualPath: video.url,
					imgURL: video.feed_url || video.url,
					isVideo: true,
					source: new RegExp(/youtu\.?be/i).test(video.feed_url || video.url) ? "YOUTUBE" : "MANUAL",
					status: "REVIEWED",
					thumbnailURL: video.thumbnail,
					uploaded: true,
					videoName: video.title,
					isEnrich: true,
			}
			}
			productData.videoUrlIds = [videoId];
			dispatch({ type: ADD_VIDEO_TO_LIBRARY , payload: videoData });
		}
		if(productData?.detailsSpecification){
			dispatch(updateBrandManufactureDetails({
				detailsSpecification: productData.detailsSpecification
			}))
		}
		dispatch({
			type: EDIT_ENRICH_PRODUCT,
			payload: {
				productData,
				oldProductData: [],
				bizSuggestion,
				oldBizSuggestion: [],
				videos: state.videoLibrary.videos,
				attachmentData: [],
				isEnrich: true
			}
		});
		cb && cb();
	} else {
		productData = {
			...res.data.data,
			error: true
		};
		productData.productId = productBankId;
		dispatch({
			type: EDIT_ENRICH_PRODUCT,
			payload: {
				productData,
				bizSuggestion: {},
				videos: state.videoLibrary.videos,
				attachmentData: [],
				isEnrich: true
			}
		});
		cb && cb();
	}
};

export const getProductData = ({ productId, isDuplicate, isObjectionable = false, isBrandedProd = false, id, isTemplateProduct = false, isTemp = false, viaSuggested = false, cb }) => async (dispatch, getState) => {
	const flowCheck = identifyAuditFlow({ checkType: true });
	let { queueType = '', isGenericProduct = '' , mrpAuditConsignmentNo = '',omni = 0, selectedProductType = '' } = identifyAuditFlow({ query: true });
	let isSpecialContract = flowCheck.isSpecialContract;
	const state = getState();
	const editProduct = state.products.editProduct || {};
	console.log('editProductData', { id, productId })
	if (productId == 'ADD_PRODUCT' && !isTemp) {
		if (isSpecialContract) {
			const docIdCheck = identifyAuditFlow({ query: true });
			let docId = "";
			if (docIdCheck.searchBy == 'docId') {
				docId = docIdCheck.docId;
			}
			const res = await axios.get(
				apiDomain +
				`/marketplace/static/php/web/b2bWebsite.php?action=getAuditEmptyData&docid=${docId}`
			);
			if (res.data.status) {
				dispatch({
					type: INIT_ADD_PRODUCT,
					payload: {
						...res.data,
						viaOmni:state.session.viaOmni
					},
				});
			}
		} else {
			dispatch({
				type: INIT_ADD_PRODUCT,
				payload: {
					viaSuggested,
					selectedProductType,
					viaOmni:state.session.viaOmni || !!omni
				},
			});
		}
		return;
	}else if(productId == 'ADD_PRODUCT' && isTemp){
		dispatch({
			type: SHOW_PRODUCT_EDIT_SLIDER,
			payload: {
				viaSuggested,
				viaOmni:state.session.viaOmni
			},

		})
		return;
	}
	const token = state.session.token;
	let isAuditUrl = false;
	let useAuditApi = false;
	let objectionApi = false;
	let brandedApi = false;
	if (flowCheck.fetchNextAudit) {
		isAuditUrl = true;
	}
	if (flowCheck.searchAudit) {
		useAuditApi = true;
	}
	if (isObjectionable || flowCheck.isObjectionable) {
		objectionApi = true;
	}
	if (isBrandedProd || flowCheck.isBrandedProd) {
		brandedApi = true;
	}
	if (isGenericProduct) {
		isTemplateProduct = true;
	}
	const res = await axios.get(
		apiDomain +
		`/marketplace/static/php/web/b2bWebsite.php?action=getProductDetails&token=${token}&productId=${isTemp?id:productId}
		${objectionApi ? `&id=${id ? id : productId}` : ''}
		${isAuditUrl ? `&isAuditUrl=true&queueType=${queueType}${mrpAuditConsignmentNo ? `&mrpAuditConsignmentNo=${mrpAuditConsignmentNo}` : ''}` : ''}
		${useAuditApi ? '&isSearchAudit=true' : ''}
		${brandedApi ? `&isBrandedProd=1` : ''}
		${isTemplateProduct ? `&generic_p_id=${productId}&isGenericProduct=true` : ''}
		${state.session.viaOmni ? `&viaOmni=1`: ''}`
	);
	if(queueType){
		dispatch({
			type: SET_QUEUE_TYPE,
			payload: {
				queueType
			}
		});
	}
	if (res.data.status == 1) {
		const productData = res.data.data;
		const bizSuggestion = res.data.bizSuggestion;
		let imgUrls = productData.imageUrl+(productData.ApprovedLabelImageUrl?','+productData.ApprovedLabelImageUrl:'')
		productData.imageUrlArr = formatMediaUrl(imgUrls, productData.videoUrl,'', ((productData.isTempProd || productData.isTemplate) && productData?.showUpload !== 1),productData.ApprovedLabelImageUrl);
		if (isDuplicate) {
			productData.productId = 'ADD_PRODUCT';
			productData.isDuplicate = true;
			productData.sku = productData.categoryType == 'service' ? '' : productData.sku;
			productData.imageUrlArr = productData.imageUrlArr.filter(cur => !cur.imgURL.includes("rep/b2b"));
		}
		if (isTemplateProduct && productData.generic_p_id) {
			productData.productId = 'ADD_PRODUCT';
		}
		productData.isAlreadyAudited = res.data.isAlreadyAudited;
		productData.checkBoxOptions = res.data.checkBoxOptions;
		productData.showAuditData = res.data.auditData;
		productData.timestampAudit = res.data.timestampAudit;
		productData.countPerDocId = res.data.countPerDocId;
		productData.buyOnlineUrl = res.data.buyOnlineUrl ? res.data.buyOnlineUrl : "";
		productData.actualProductWeight = productData.actualProductWeight ? productData.actualProductWeight : '';
		productData.oldProductWeight = productData.actualProductWeight ? productData.actualProductWeight : '';
		productData.isSellOnline = productData.isSellOnline;
		productData.productLength = productData.productLength ? productData.productLength : '';
		productData.productWidth = productData.productWidth ? productData.productWidth : '';
		productData.productHeight = productData.productHeight ? productData.productHeight : '';
		productData.quantity = isDuplicate ? '' : (productData?.quantity && productData?.quantity.toString() != '0' ? String(productData.quantity) : '');
		productData.mrp = productData.mrp && Number(productData.mrp?.toString()?.replaceAll(',','')) > 0 ? checkForTrailingZeroes(productData.mrp?.toString()?.replaceAll(',','')) : '';
		productData.sellingOnlinePrice = productData.sellingPrice && Number(productData.sellingPrice?.toString()?.replaceAll(',','')) > 0 ? checkForTrailingZeroes(productData.sellingPrice?.toString()?.replaceAll(',','')) : '';
		productData.barcode = productData.barcode ? productData.barcode : '';
		productData.oldPriceObj = productData.priceObj ? productData.priceObj : '';
		productData.description = productData.description ? formatProdDesc(productData.description) : "";
		productData.newconsignmentNo = productData.consignment_no_display && !isDuplicate ? productData.consignment_no_display : ''
		productData.JdMartPdpLink = res.data?.JdMartPdpLink
		productData.oldSellOnlineObj = {
			quantity: productData.quantity ? productData.quantity : 0,
			mrp: productData.mrp ? productData.mrp : 0,
			sellingPrice: productData.sellingPrice ? productData.sellingPrice : 0,
			barcode: productData.barcode ? productData.barcode : ''
		}
		productData.categoryType = productData.categoryType?.toLowerCase();
		productData.bestBeforeUnit = productData.best_before ? productData.best_before.split('-')[1].toLowerCase() : "months"
		if (productData.countryOrigin && productData.countryOrigin && productData.countryOrigin[0] && productData.countryOrigin[0].values) {
			// let countryValue = productData.countryOrigin[0].values.split('|~|');
			// let countryData = {
			// 	countryName: countryValue[0] ? countryValue[0] : '',
			// 	countryCode: countryValue[1] ? countryValue[1] : ''
			// }
			// productData.countryOrigin = { ...countryData }
		} else {
			productData.countryOrigin = {}
		}
		if (productData.manufacturing_date) {
			let tempDateObj = productData.manufacturing_date.split('T')[0];
			let manufDate = tempDateObj.split('-').reverse();
			productData.manufacturing_date = manufDate.join('/');
			// let tempExp = productData.expiry_date.split('T')[0]
			// let expDate = tempExp.split('-').reverse();
			// productData.expiry_date = expDate.join('/');
		}
		if (productData.expiry_date) {
			let tempDateObj = productData.expiry_date.split('T')[0];
			let expDate = tempDateObj.split('-').reverse();
			productData.expiry_date = expDate.join('/');
			// let temManf = productData.manufacturing_date.split('T')[0];
			// let manExp = temManf.split('-').reverse();
			// productData.manufacturing_date = manExp.join('/');
		}
		if(typeof productData.gstRate === 'number' || productData.gstRate){
			productData.gstRate = String(productData?.gstRate);
			productData.gstCess = String(productData?.gstCess);
		}
		productData.expiryBy = Number(productData.manufacturing_date_flag) == 1 ? 'manufacturing_date' : 'expiry_date';
		if(productData.categoryType === 'service' && productData.unitOfMeasurement === 'stds'){
			productData.specificDuration = productData.customDuration;
			productData.specificDurationUnit = productData.customUnit;
		}
		if (productData.best_before) {
			productData.best_before = productData.best_before.split("-")[0];
		}
		if (productData.commissionPerc) {
			if (typeof productData.commissionPerc == 'string' && productData.commissionPerc.includes(".")) {
				//Remove Decimal for .00
				productData.commissionRate = "" + Number(productData.commissionPerc);
			} else {
				productData.commissionRate = productData.commissionPerc;
			}
		} else {
			productData.commissionRate = ''
		}
		if(productData.compliance){
			let complianceCount = 0;
			Object.keys(productData.compliance).map(cur => {
                if(!['hsn','tax_rate','importer','importers_detail','country_of_origin','manufacturer','manufactured_details','price','packaging_width','packaging_height','packaging_length','packaging_weight','expiry_date','brand'].includes(cur.toLowerCase()) && !productData.compliance[cur]){
                  complianceCount ++;
                }
            })
			productData.hasCompliance = complianceCount;

		}
		let headerData = res.data.headerData;
		if (headerData) {
			productData.jdWebsiteUrl = headerData.companyWebsiteLink;
			productData.jdBestPracticeWebsiteUrl = headerData.bestPracticeWebsiteLink;
			productData.jdCatList = headerData.keywordList;
			productData.jdLink = headerData.jdLink;
			productData.contractorProvidedWebsite = headerData.contractorProvidedWebsite;
			productData.audtTimeStamp = res.data.timestamp;
			productData.createdOnAudit = res.data.createdOnAudit;
			productData.contractorName = res.data.contractorName;
			productData.contractorMobile = res.data.contractorMobile;
			productData.contractorType = res.data.contractorType;
			productData.bucketId = res.data.bucketId;
			productData.source = headerData.source;
		}
		if (res.data.queueType) {
			productData.queueType = res.data.queueType;
		}
		if (res.data.dataSource) {
			productData.dataSource = res.data.dataSource;
		}
		// sourceFiles may arrive nested under dataSource, or as a sibling of it — support both.
		const effectiveSourceFiles = res.data.dataSource?.sourceFiles || res.data.sourceFiles;
		if (effectiveSourceFiles) {
			productData.sourceFiles = effectiveSourceFiles;
		}
		if (isAuditUrl && isDuplicate) {
			const docIdCheck = identifyAuditFlow({ query: true });
			let docId = "";
			if (docIdCheck.searchBy == 'docId') {
				docId = docIdCheck.docId;
			}
			const response = await axios.get(
				apiDomain +
				`/marketplace/static/php/web/b2bWebsite.php?action=getAuditEmptyData&docid=${docId}`
			);
			if (response && response.data && response.data.status) {
				productData.checkBoxOptions = response.data.data;
			}
		}
		if((res.data.data.variantCommands && res.data.data?.variantCommands[0]?.list?.length) || (res.data.data.variantJson && res.data.data.variantsInventoryJson)){
			const videoLibrary = getState().videoLibrary?.videos;
			const variantData = res.data.data.variantJson?formatVariantForObjection(res.data.data,videoLibrary,productData):formatVariantData(res.data.data.variantCommands, videoLibrary, isDuplicate,productData.unitOfMeasurement,state.session?.viaOmni)
			if(state.session.viaOmni && (!productData.mrp || Number(productData.mrp || 0) <  Number(productData.sellingPrice || 0))) {
				productData.sellingPrice = '';
				productData.sellingOnlinePrice = '';
				productData.consignment_selling_price = '';
				productData.oldSellOnlineObj = {
					...productData.oldSellOnlineObj,
					mrp: '',
					sellingPrice: '',
				};
			}
			dispatch({
				type: 'SET_EDIT_VARIANT_DATA',
				payload: {
					...variantData,
					viaOmni:state.session.viaOmni,
				}
			})
		}
		// if(productData.detailsSpecification){
		// 	dispatch(updateBrandManufactureDetails({
		// 		detailsSpecification: productData.detailsSpecification
		// 	}))
		// }
		if(state.session.viaOmni) {
			productData.selectedProductGroupIds = productData?.selectedProductGroupIds ? productData?.selectedProductGroupIds.toString() : ''
			productData.productGroup = productData?.productGroup ? productData?.productGroup.toString() : '' 
		}
		dispatch({
			type: EDIT_PRODUCT,
			payload: {
				productData,
				oldProductData: res.data.oldData,
				bizSuggestion,
				oldBizSuggestion: res.data.oldBizSuggestion,
				videos: state.videoLibrary.videos,
				attachmentData: res.data.attachmentData && res.data.attachmentData.data ? res.data.attachmentData.data : [],
				isDuplicate,
				viaSuggested,
				viaOmni:state.session.viaOmni,
			}
		});
		cb && cb();
	} else {
		dispatch({
			type: EDIT_PRODUCT,
			payload: {
				productData: {
					...res.data.data,
					error: true
				},
				bizSuggestion: {},
				videos: state.videoLibrary.videos,
				attachmentData: [],
				viaSuggested,
				viaOmni:state.session.viaOmni,
			}
		});
		cb && cb();
	}
};

export const updateViaSuggested = payload => {
	return {
		type: SET_VIA_SUGGESTED,
		payload
	};
};

export const updateSuggestedViaSearch = payload => {
	return {
		type: SET_SUGGESTED_VIA_SEARCH,
		payload
	};
}

export const setShouldRetainScroll = payload => {
	return {
		type: SET_SHOULD_RETAIN,
		payload
	}
}

export const updateEditProductDetail = payload => {
	return {
		type: UPDATE_EDIT_PRODUCT_DETAIL,
		payload
	};
};

export const getSearchData = ({
	pageNo = 1,
	supplierId,
	searchText
}) => async (dispatch, getState) => {
	const state = getState();
	const token = state.session.token;
	let isAuditSearch = '';
	const docIdCheck = identifyAuditFlow({ query: true });
	if (docIdCheck.searchBy == 'docId') {
		isAuditSearch = "&isAuditSearch=true";
	}
	let strUrl = `${apiDomain}/marketplace/static/php/web/b2bWebsite.php?action=searchProduct&token=${getSearchToken({ token })}&pageNo=1&searchStr=${searchText}${isAuditSearch}`;
	const res = await axios.get(strUrl);

	dispatch({
		type: SET_SEARCH_DATA,
		payload: {
			...res.data.data,
			currentPage: pageNo,
			searchQuery: searchText,
			videos: state.videoLibrary.videos
		}
	});
};

export const resetSearchData = () => async dispatch => {
	dispatch({
		type: EMPTY_SEARCH_DATA,
		payload: {}
	});
};

export const updateProductMedia = payload => (dispatch, getState) => {
	const state = getState();
	if (payload.forVideo) {
		//change
		const { videoLibrary } = state;
		let videoLinkedToVariant = true;
		if (payload.imageUrl.forUpload) {
			const curVideo = videoLibrary.videos[payload.imgIndex] || {};
			const variantIdsToLink = [...curVideo.variantIdsToLink];
			if (!variantIdsToLink.includes(payload.productId)) {
				videoLinkedToVariant = false;
			}
		}
		updateVideoInLibrary({
			...payload.imageUrl,
			ignoreSave: payload.ignoreSave,
			editProductId: payload.editProductId,
			token: state.session.token,
			isAddEditProduct: payload.isAddEditProduct,
			isAddEditProductOmni:payload.isAddEditProductOmni,
			isEnrchProductPage: payload.isEnrchProductPage,
			isEnrich: payload.isEnrich
		})(dispatch, getState)
		if (!videoLinkedToVariant) {
			return;
		}
	}
	if(payload.forVideo && (payload.isAddEditProduct || payload.isAddEditProductOmni || payload.isEnrchProductPage)){
		dispatch({
			type: UPDATE_PRODUCT_VIDEO_FROM_ADD_EDIT,
			payload:{
				...payload,
				token: state.session.token
			}
		})
	}else{
		dispatch({
			type: payload.forVideo ? UPDATE_PRODUCT_VIDEO : (payload.isAddEditProduct || payload.isAddEditProductOmni || payload.isEnrchProductPage) ? UPLOAD_IMAGE_FROM_ADD_EDIT : UPDATE_PRODUCT_IMAGE,
			payload: {
				...payload,
				token: state.session.token
			}
		});
	}
};

export const updateApprovalPending = payload => (dispatch) => {
	dispatch({
		type: SET_APPROVAL_PENDING,
		payload: payload
	});
}

export const updateProductConflict = payload => (dispatch) => {
	dispatch({
		type: SET_PRODUCT_CONFLICT,
		payload: payload
	});
}

export const updateAuditPending = payload => (dispatch) =>{
	dispatch({
		type: SET_AUDIT_PENDING,
		payload: payload
	});
}


export const updateRejectedProducts = payload => (dispatch) =>{
	dispatch({
		type: SET_REJECTED_PRODUCTS,
		payload: payload
	});
}

export const updateDeletionPending = payload => (dispatch) => {
	dispatch({
		type: SET_DELETION_PENDING,
		payload: payload
	});
}

export const updateBrand = payload => (dispatch) => {
	dispatch({
		type: SET_BRAND_PROD_SELECTION,
		payload: payload
	});
}

export const updateObjectionalPending = payload => (dispatch) => {
	dispatch({
		type: SET_OBJECTIONAL_PENDING,
		payload: payload
	});
}

export const updateBrandPending = payload => (dispatch) => {
	dispatch({
		type: SET_BRAND_PENDING,
		payload: payload
	});
}

export const updateGenericDeletionPending = payload => (dispatch) => {
	dispatch({
		type: SET_GENERIC_DELETION_PENDING,
		payload: payload
	});
}

export const setTabStatus = payload => (dispatch) => {
	dispatch({
		type: SET_TAB_STATUS,
		payload: payload
	});
}

export const toggleAddProductSlider = payload => (dispatch) => {
	dispatch({
		type: TOGGLE_ADD_PRODUCT_SLIDER,
		payload : payload
	})
}
export const toggleAddEditButtonAnimation = payload => (dispatch) => {
	dispatch({
		type: TOGGLE_ADD_EDIT_BUTTON_ANIMATION,
		payload : payload
	})
}

export const toggleEditProductSlider = payload => (dispatch) => {
	dispatch({
		type: FROM_EDIT_PRODUCT_SLIDER,
		payload : payload
	})
}

export const toggleSearchSlider = payload => (dispatch) => {
	dispatch({
		type: TOGGLE_SEARCH_SLIDER,
		payload: payload
	});
}
export const toggleActionCardSlider = payload => (dispatch) => {
	dispatch({
		type: TOGGLE_ACTION_CARD_SLIDER,
		payload: payload
	});
}

export const toggleSupportSlider = payload => (dispatch) => {
	dispatch({
		type: TOGGLE_SUPPORT_SLIDER,
		payload
	})
}

export const actionCardFilter = payload => (dispatch) => {
	dispatch({
		type: ACTION_CARD_FILTER,
		payload: payload
	});
}

export const reloadActionCardSlider = payload => (dispatch) => {
	dispatch({
		type: RELOAD_ACTION_CARD_SLIDER,
		payload: payload
	});
}

export const deleteProductVideo = payload => async (dispatch, getState) => {
	const { session, videoLibrary, products } = getState();
	const token = session.token;
	/*
		payload: {
			variantId,
			videoId
		}
	*/
	if(payload.isAddEditPage){
		if(products.imagesBeingUploaded?.length) {
			products.imagesBeingUploaded.map(el => {
				if(el.forVideo) {
					dispatch({
						type: UPDATE_IMAGES_BEING_UPLOADED,
						payload: products.imagesBeingUploaded.filter(cur => !cur.forVideo)
					})
				}
			})
		}
		dispatch({
			type: UNLINK_VIDEO_TOP_RODUCT_FROM_ADD_EDIT,
			payload
		});
		dispatch({
			type: REMOVE_VIDEO_FROM_ADD_EDIT,
			payload
		})
	}else{
		dispatch({
			type: UNLINK_VIDEO,
			payload
		})
	}
	const curVideo = videoLibrary.videos[payload.videoId] || {};
	if (curVideo.uploaded && !payload.ignoreSave) {
		delete payload.videoId //required
		await linkUnlinkVideoRequest(payload, token);
	}
}

export const toggleEditImageOptions = payload => ({
	type: TOGGLE_EDIT_IMAGE_OPTIONS,
	payload
});

export const deleteProductImage = payload => async (dispatch, getState) => {
	const state = getState();
	const finalImageUrl = [],
		finalVideoUrl = {};
	payload.imageUrlArr.map((imgObj, index) => {
		if (imgObj.isVideo) {
			finalVideoUrl[index] = {
				imgURL: imgObj.imgURL,
				thumbnailURL: imgObj.thumbnailURL
			};
		} else {
			finalImageUrl.push(imgObj.imgURL);
		}
	})
	!payload.ignoreSave &&
		updateProductMediaService({
			...payload,
			imageUrl: finalImageUrl.join(','),
			videoUrl: JSON.stringify(finalVideoUrl),
			source: state.session.source
		});
		payload.isAddEditPage ?
		dispatch({
			type: DELETE_IMAGE_FROM_ADD_EDIT,
			payload
		}):
		dispatch({
			type: DELETE_PRODUCT_IMAGE,
			payload
		});
};

export const restoreProductData = payload => async (dispatch, getState) => {
	const { products, session } = getState();
	const undoInfo = products.undoInfo || {};
	if (undoInfo.type === 'image') {
		dispatch({
			type: RESTORE_PRODUCT_DATA,
			payload: {
				token: session.token,
				source: session.source
			}
		})
	} else if (undoInfo.type === 'video') {
		undoInfo.videoId = undoInfo.data.videoId;
		selectVideo(undoInfo)(dispatch, getState);
	}
}

export const updateImagesBeingUploaded = (payload) => ({
	type: UPDATE_IMAGES_BEING_UPLOADED,
	payload
})

export const setCurrentEditPage = payload => ({
	type: SET_CURRENT_EDIT_PAGE,
	payload
});

export const setFileAttachmentPermission = payload => ({
	type: FILE_ATTACHMENT_PERMISSION,
	payload
});

export const discardAddProductMedia = () => async (
	dispatch,
	getState
) => {
	const { products } = getState();
	const productData = products.editProduct;
	const imagesBeingUploaded = [...products.imagesBeingUploaded];
	let productId = productData.productId;
	if (productId === 'ADD_PRODUCT' && imagesBeingUploaded.length) {
		imagesBeingUploaded.forEach((cur) => {
			if (cur.productId === 'ADD_PRODUCT' && mediaApiCancelTokens[cur.imgIndex]) {
				mediaApiCancelTokens[cur.imgIndex](`Old Add Product Request ${cur.imgIndex}`);
			}
		})
	}
	dispatch({
		type: DISCARD_ADD_PRODUCT_MEDIA
	})
}

const getAuditorData = (options = {}) => {
	let result = {};
	const flowCheck = identifyAuditFlow({ checkType: true });
	let useAuditApi = false;
	if (flowCheck.searchAudit) {
		useAuditApi = true;
		result.isSearchAudit = true;
	}
	if (flowCheck.fetchNextAudit) {
		let { state } = options;
		let auditData = state.products.auditData;
		result.isAuditUrl = true;
		result.radioBtnSelected = auditData.checkedValue;
		result.checkBoxData = [];
		if (auditData.checkedValue == "minCorrect") {
			result.description = auditData.minCorrectTextArea;
			result.checkBoxData = auditData.newCheckBoxData
		} else if (auditData.checkedValue == "errWithDet") {
			result.checkBoxData = auditData.newCheckBoxData
			if(auditData.textBoxValue){
				result.description = auditData.textBoxValue
			}
		} else if(auditData.checkedValue == "productRejected" || auditData.checkedValue == "PRODUCT_REJECTED_FOR_LABEL"){
			result.checkBoxData.push(auditData.rejectionMessage);
		} else if(auditData.checkedValue == "mergeWithBrandedProduct"){
			result.productId = auditData.brandedProductId;
		}
	}
	return result;
};
export const filterSpecification = ({ attributes, customAttrs }) => {
	return queryString.stringify({
		attributes: JSON.stringify(filterCatAttributes(attributes)),
		custAttributes: JSON.stringify(filterCustomAttr(customAttrs))
	})
}
const filterCustomAttr = (customAttrs) => {
	return customAttrs && customAttrs.reduce((arr, attr) => {
		let name = (attr.name || '').trim();
		let value = (attr.value || '').trim();
		if (name) {
			name = name.replace(/:$/, "");
			name = name.trim();
		}
		if (value) {
			value = value.replace(/^:/, "");
		}

		if (!name || !value) {
			return arr;
		}

		arr.push({ name, value });

		return arr;
	}, []);
}
const filterCatAttributes = (attributes) => {
	let returnObj = [];
	attributes.forEach((cur, index) => {
		const otherFlag = cur.otherFlag ? 1 : 0
		const name = otherFlag ? attributes[index - 1].name : cur.name;
		let values = cur.values;
		if (otherFlag) {
			const prevValues = attributes[index - 1].values;
			const i = prevValues.indexOf("other");
			if (prevValues.splice) {
				prevValues.splice(i, 1);
			}
		}
		returnObj.push({
			name: name,
			type: cur.type,
			sid: cur.sid ? cur.sid : '',
			values,
			otherFlag
		})
	})
	returnObj = returnObj.filter(cur => cur.values && cur.values.length);
	return returnObj;
}
let imagesFromPhotoGallery = '';
const getVariantImgObj = (arr) => {
	let imageObj = {};
	let length = arr?.length;
	let imgString = '';
	for(let i=0,index=1;i<length;i++,index++){
		const image = arr[i] ? (arr[i].imgURL || arr[i].imageUrl || arr[i].imageURL) : ""
		if(image)
			imgString += image+(i==length-1?'':',');
		if(arr[i]?.galleryId){
			if(imagesFromPhotoGallery.split().indexOf(arr[i].galleryId) == -1){
				imagesFromPhotoGallery = imagesFromPhotoGallery + (imagesFromPhotoGallery ? ','+arr[i].galleryId : arr[i].galleryId)
			}
		}
	}
	imageObj['productImage'] = imgString;
	return imageObj;
}

const getFormattedAttrVal = (info) => {
	let arr = [];
	for(let i=0;i<info.length;i++){
		arr[i] = Object.keys(info[i])[0] + ";" + info[i][Object.keys(info[i])[0]];
	}
	return arr;
}

const formVariantData = (productData,state,productOrService,viaOmni = false) => {
	let variantJson = [];
	let variantsInventoryJson = [];
	let variantProductData = state.variants.variantProductData?.length?[...state.variants.variantProductData]:[];
	variantProductData.map((item,index)=>{
		let photoUrlObj = getVariantImgObj(variantProductData[index].imageUrlArr);
		const idForEdit = productData.productId != 'ADD_PRODUCT' ? productData.productId : 0;
		const oldData = state.variants?.variantCommand?.apiData[index] || {}

			//New Variant
		if(productOrService == 'product') {
			variantsInventoryJson[index] = {
				newmrp: item.mrp ? Number(item.mrp) : '',
				newsellingPrice: item.sp ? Number(item.sp) : '',
				newcostPrice: item.cp ? Number(item.cp) : '',
				newQuantity: !viaOmni && (oldData.totalQuantity && item.quantity && !productData.isDuplicate) ? Number(item.quantity -  oldData.totalQuantity) : item.quantity || '',
				barcode: item.barcode || '',
				newConsignmentNo: item.batch || oldData.consignmentCommand?.consignment_no_display,
				consignment_no_display: item.batch || oldData.consignmentCommand?.consignment_no_display,
				newSku: item.sku ? item.sku : ''
			}
		} else {
			variantsInventoryJson[index] = {
				newactualPrice: item.actualPrice ? Number(item.actualPrice) : item.discPrice ? Number(item.discPrice) : '',
				newdiscPrice: item.discPrice ? Number(item.discPrice) : item.actualPrice ? Number(item.actualPrice) : ''
			}
		}
		let tmpVideoId = item.videoUrlArr?.length ? [item.videoUrlArr[0].videoId] : null

		if(state.session.viaOmni){
			variantsInventoryJson[index].costPrice=  item.cp ? Number(item.cp) : ''
			if(item.expiryDate){				
				variantsInventoryJson[index].expiry_date=item.expiryDate.split("/").reverse().join("-")+" 12:59:59"
				variantsInventoryJson[index].manufacturing_date=""
				variantsInventoryJson[index].best_before=""
			} else{
				variantsInventoryJson[index].expiry_date=""
			}
			if(item.manufacturingDate && item.bestBefore){
				variantsInventoryJson[index].manufacturing_date=item.manufacturingDate.split("/").reverse().join("-")+" 12:59:59"
				variantsInventoryJson[index].best_before=item.bestBefore+"-"+item.bestBeforeUnit
				variantsInventoryJson[index].expiry_date=""
			} else{
				variantsInventoryJson[index].manufacturing_date=""
				variantsInventoryJson[index].best_before=""
			}

			variantsInventoryJson[index] = {
				...variantsInventoryJson[index],
				isAutoReorderLevel: item?.isAutoReorderLevel ? true : false,
				isAutoReorderQuantity: item?.isAutoReorderQuantity ? true : false,
				reorderLevel: item?.reorderLevel || '',
				reorderQuantity: item?.reorderQuantity || ''
			}


			// if (!(variantsInventoryJson[index].expiry_date && variantsInventoryJson[index].manufacturing_date)) {
			// 	variantsInventoryJson[index].manufacturing_date="2024-01-01 12:59:59"
			// 	variantsInventoryJson[index].best_before="2-months"
			// }
			
		}

		if(productOrService == 'service') {
			photoUrlObj = getVariantImgObj(productData.imageUrlArr);
			tmpVideoId = productData?.videoUrlIds?.length ? [productData.videoUrlIds[0]] : null
			if(productData.unitOfMeasurement == 'stds') {
				item.uom = (item.specificDuration || 1) + ' ' + (item.specificDurationUnit || 'months');
			}else if(!['Sess','Visit'].includes(productData.unitOfMeasurement)) {
				item.uom = productData.unitOfMeasurement;
			}else {
				item.uom = item.uom ? item.uom : (item.customDuration || 1)+' '+productData.unitOfMeasurement;
			}

		}
		variantJson[index] = {
			photoUrls: "",
			videoUrlIds: tmpVideoId,
			puvAttrValues: [],
			customAttributeValues: getFormattedAttrVal(state.variants.variantCombinations[index]),
			benchmarkUrl: "",
			isActive: item.showOnWebsite ? true : false,
			id: idForEdit,
			productId: !productData.isDuplicate && item.variantId?item.variantId:'',
			unit_of_measurement: item.uom ? item.uom : '',
			status: "",
			isAutoReorderLevel: item?.isAutoReorderLevel ? true : false,
			isAutoReorderQuantity: item?.isAutoReorderQuantity ? true : false,
			reorderLevel: item?.reorderLevel || '',
			reorderQuantity: item?.reorderQuantity || '',
			...photoUrlObj,
		}
	})
	return {
		variantJson: JSON.stringify(variantJson),
		variantsInventoryJson: JSON.stringify(variantsInventoryJson)
	}
}

const replaceMultipleSpaces = (data) => {
	//description, Specs value , name and Description
	let newData = {...data};
	let specs = JSON.parse(newData.specification);
	let trimmedSpecs = [];
	if(Array.isArray(specs) && specs.length) {
		specs.map(curSpec => {
			let trimmedValue = Array.isArray(curSpec.values) ? curSpec.values.map(cur => {
					return cur.replace(/\s+/g,' ');
				}) : (typeof curSpec.values == 'string' ? curSpec.values.replace(/\s+/g,' ') : curSpec.values);
			trimmedSpecs.push({
				...curSpec,
				values: trimmedValue
			})
		})
	}
	newData.productName = newData.productName.replace(/\s+/g,' ');
	newData.description = newData.description.replace(/\s+/g,' ');
	newData.specification = JSON.stringify(trimmedSpecs);
	return newData;
}

const formatDimensionInSpec = (specs,data) => {
	if (!Array.isArray(specs) || !specs.length) return [];
	let sidMap = {
		productHeight: '5724',
		productWidth: '5723',
		productLength: '11426',
		actualProductWeight: '7926'
	};
	let dataToSend = [];
	Object.keys(sidMap).map(cur => {
		let specData = specs.find(el => el?.s_id?.toString() === sidMap[cur]);
		if(specData){
			let val = data[cur];
			if(cur == 'actualProductWeight') {
				specData.userInput.sunit = 'kg'
				if(data.packUnit == 'Gm' && data[cur]) {
					val = (Number(data[cur])/1000)?.toString();
				}
			}else {
				specData.userInput.sunit = 'cm'
			}
			specData.userInput.value = val;
			dataToSend.push(specData);
		}
	})
	return dataToSend.length?getAllSpecificationData(dataToSend,[]):[];
}
export const saveEnrichEditPorduct = (payload, cb, options = {}) => async (dispatch, getState) => {
	const state = getState();
	const productData = state.products.editProduct;
	const videos = state.videoLibrary.videos;
	let videoUrlIds = [];
	let data = {
		content: [],
		specification: [],
		details: [{value: '', attribute_name:"description"}],
		reference_links: [],
		contractor: state.session.user.loggedUser?.userName
	}

	if (productData?.videoUrlIds.length) {
		videoUrlIds = productData?.videoUrlIds.filter((cur) => {
			return videos[cur] && videos[cur].uploaded
		})
	}


	const mediaArr = [...productData.imageUrlArr, ...productData.videoUrlArr];
	let contentData = [];
	let index = 0;
	let videoCounter = 0;
    mediaArr.forEach((media,i) => {
    	index = i+1;
    	if(media.isVideo){
    		contentData.push({type: 'video', video1: (media.newVideoId ? media.newVideoId : (videoUrlIds[videoCounter] ? videoUrlIds[videoCounter] : 0)), isDefault: '', position: 1, view_type: 0})
			videoCounter++;
    	} else {
    		contentData.push({type: 'image', ['img'+index]: media.imgURL, isDefault:index === 1, position: index, view_type: 0})
    	}
    });

	if (Number(productData.lbl_img_mandatory)==1) {
		let tempCounter = 1;
		if(productData?.label_front_image?.length) {
			productData.label_front_image.map((cur,index) => {
				contentData.push({type: 'label_image', ['img'+(tempCounter).toString()]: cur.url, isDefault:index === 0, position: (tempCounter), view_type: 1});//1 = front view
				tempCounter++;
			})
		}
		if(productData?.label_image?.length) {
			productData.label_image.map((cur,index) => {
				contentData.push({type: 'label_image', ['img'+(tempCounter).toString()]: cur.url, isDefault:index === 0, position: (tempCounter), view_type: 2});//2 = back view
				tempCounter++;
			})
		}
	} else {
		productData.label_image.map((cur,index) => {
			contentData.push({type: 'label_image', ['img'+(index+1).toString()]: cur.img, isDefault:index === 0, position: cur.position, view_type: cur.view_type});
		})
	}

	data.content = JSON.stringify(contentData);

	let specificationData = [];
	state.productSpecification.editablePuvSpecAttributes.map(({s_nm,s_id,userInput:{value}})=>{
        specificationData.push({
            attribute_name:s_nm,
            value,
            sid:s_id
        });
    });
	if(options.hasOwnProperty("savedCustomSpecAttributes")){
		options.savedCustomSpecAttributes.map(({key, value})=>{
			if (key.value && value.value) {
				specificationData.push({
					attribute_name:key.value,
					value: value.value,
					is_custom:1
				});
			}
		});
	}
	data.specification = JSON.stringify(specificationData);
	let referenceLinksData = [];
	productData.referenceLinks.map((reference, refIndex) => {
		referenceLinksData.push(reference.link);
	});
	data.reference_links = JSON.stringify(referenceLinksData);
	let description=productData.description;
	description = formatProdDesc(description);
	data.details[0].value = description;

	data.details = JSON.stringify(data.details);
	let url = '/vendorapis/contractor/contractor/saveEnrichmentProduct?productId='+productData.productId.toString();
	data = queryString.stringify(data);
	axios
		.post(url, data)
		.then(async res => {
			let productId = productData.productId;
			if (!res.data?.errors && res.data?.results?.code == 0) {
				const response = {
					isSuccess: true,
					data: res.results
				}
				cb && cb(response);
				dispatch({
					type: SAVE_ADD_EDIT_PRODUCT,
					payload: {
						...payload,
						productId
					}
				});
			} else {
				cb && cb({
					isSuccess: false,
					data: res.data.errors
				});
			}
		});

};

const getImageUrlLabel = (images,productData) => {
	let imgStr = ''
	if(images?.length) {
		images.map((cur,index) => {
			if(cur?.url){
				imgStr += cur.url+(index == productData.label_image.length - 1? '':',');
			}else{
				imgStr += cur+(index == productData.label_image.length - 1? '':',');
			}
		})
	}
	return imgStr;
}

export const saveAddEditProduct = (payload, cb, options = {}) => async (dispatch,getState) => {
	const state = getState();
	const productData = state.products.editProduct;
	const isCorrector = state.session.user.loggedUser?.subType === "CORRECTOR"   
	const tabKey = (state.products.tabKey == 'brand') ? '' : state.products.tabKey;
	const tabIndex = (state.products.tabKey == 'brand') ? 0 :  state.products.tabIndex;
	const listingProdData = state.products.listing;
	const videos = state.videoLibrary.videos;
	const vendorImages = state.products.vendorImages || [];
	let productId = productData.productId;
	let selectedCategoryType =  state.products.selectedCategoryType;
	if(productData.type == "SERVICE" && (state.products.tabKey == 'brand' || state.products.search.searchTab == 'brand' || state.products.isAddProductSlider)){
		selectedCategoryType = "service"
	}else if (productData.type == 'PRODUCT' && state.products.isAddProductSlider){
		selectedCategoryType = "product"
	}
	let genericId = productData.genericId;
	const isUnification = new URLSearchParams(window.location.search).get('unification') == '1';
	const viaOmni = state?.session?.viaOmni || false;
	let {
		imageUrlArr=[],
		videoUrlIds=[],
		fileAttachmentArr = []
	} = state.products.editProduct;

	if(!state?.products?.editProduct?.fileAttachmentArr){
		fileAttachmentArr=state?.products?.allProducts[productId]?.fileAttachmentArr || []
	}

	let finalImageUrl = [];
	let finalVideoUrl = {};
	imageUrlArr = productData.productId == 'ADD_PRODUCT' && productData.isTempProd?productData.imageUrlArr:imageUrlArr;
	const imagesToDeleteFromGallery = [];
	imageUrlArr.forEach((imgObj, index) => {
		if (imgObj.galleryId && !imgObj.jdGalleryImage) {
			imagesToDeleteFromGallery.push(imgObj.galleryId);
		}
		if (imgObj.isVideo) {
			if (imgObj.uploaded) {
				finalVideoUrl[index] = {
					imgURL: imgObj.imgURL,
					thumbnailURL: imgObj.thumbnailURL
				};
			}
		} else {
			finalImageUrl.push(imgObj.imgURL);
		}
	});

	let checkVideoIds = [];
	videoUrlIds.forEach((cur) => {
		if(videos[cur]) {
			checkVideoIds.push({vId: cur, isIdPresentInVideoArr: true});
		} else {
			checkVideoIds.push({vId: cur, isIdPresentInVideoArr: false});
		}
		
	})
	if(checkVideoIds.length > 0) {
		checkVideoIds.forEach((item) => {
			if(!item.isIdPresentInVideoArr) {
				Object.keys(videos).find((video) => {
					if(item.vId === videos[video]?.imgIndex) {
						item.vId = video;
					}
				})
			}
		});
	}

	videoUrlIds = 
		checkVideoIds
		.map((cur) => cur.vId)
		.filter((cur) => {
			return videos[cur] && videos[cur].uploaded
		})

	const attachmentData = [];
	const oldFileIds = {};
	let promiseArr = [];
	fileAttachmentArr.forEach(cur => {
		const isOldFile = productId == 'ADD_PRODUCT' && cur.isOldFile;
		const supplierId = state.session.supplierId;
		if (!isOldFile && cur.isDeleted) {
			promiseArr.push(axios.get(`/marketplace/common/php/deleteUploadedb2bFile.service?supplierId=${supplierId}&id=${cur.id}`));
		}
		if (!cur.uploaded || cur.isDeleted) {
			return;
		}
		attachmentData.push({
			fileId: cur.id,
			fileName: cur.fileName,
			fileExt: cur.ext,
		})
		if (isOldFile) {
			oldFileIds[cur.id] = attachmentData.length - 1;
		}
	})
	if (promiseArr.length) {
		await Promise.all(promiseArr);
	}
	const oldFileIdsArr = Object.keys(oldFileIds)
	if (oldFileIdsArr.length) {
		const supplierId = state.session.supplierId;
		const { data } = await axios.post("/marketplace/common/php/duplicateb2bClientFile.service?module=b2bproductattachment&supplierId=" + supplierId + "&fileIds=" + oldFileIdsArr.join());
		if (!data.isError) {
			for (var key in oldFileIds) {
				const index = oldFileIds[key];
				attachmentData[index].fileId = data[key];
			}
		}
	}
	//custom attrs formatting
	const customAttrs = filterCustomAttr(productData.customAttrs);
	const descriptionDiv = document.querySelector(".wyswig-div [contenteditable]")
	let description = descriptionDiv ? descriptionDiv.innerHTML || '' : (productData.description || '');
	let sellOnlineQuantity = productData.quantity ? productData.quantity : 0;
	if (!viaOmni && (productData.oldSellOnlineObj && productData.oldSellOnlineObj.quantity && !productData.isDuplicate)) {
		sellOnlineQuantity = sellOnlineQuantity - productData.oldSellOnlineObj.quantity;
	}
	let specsDataToSend = [];
	if(options.hasOwnProperty("savedPuvSpecAttributes") || options.hasOwnProperty("savedCustomSpecAttributes")){
		specsDataToSend = getAllSpecificationData(options.savedPuvSpecAttributes, options.savedCustomSpecAttributes);
		let filterSpecificationData = specsDataToSend.length ? specsDataToSend.filter(item => !(item.sid == '122' || ['country_of_origin','manufacturer', 'manufactured_details','importer','importers_detail'].includes(item.s_name))) : [];
		if(viaOmni) {
			let pBrandName = specsDataToSend.length ? specsDataToSend.find(item => item.sid == '122') : {};
			productData.pBrandName = pBrandName?.values || '';
		}		
		let sendBMDetails = (options.sendBMDetails && options.sendBMDetails.length) ? options.sendBMDetails : [];
		let sendData = sendBMDetails[1]?.values ?.length || sendBMDetails[3]?.values ?.length?sendBMDetails:[sendBMDetails[0]];
		specsDataToSend = [
			...filterSpecificationData,
			...sendData.filter(el => el.values.length && el.values[0]),
			...options.installData.filter(el => el.values.length)
		]
	}
	// productLength : productData.productLength,
	// 	productWidth : productData.productWidth,
	// 	productHeight : productData.productHeight,
	// 	actualProductWeight : productData.actualProductWeight,
	if(!viaOmni) {
		let dimensionSpec = formatDimensionInSpec(state.brandManufacturer.brandSpec.length?state.brandManufacturer.brandSpec:(options.savedPuvSpecAttributes || []), productData);
		if(dimensionSpec.length){
			specsDataToSend = specsDataToSend.filter(cur => !(['packaging_width','packaging_height','packaging_length','packaging_weight'].includes(cur.s_name)));
		}
		specsDataToSend = [...specsDataToSend,...dimensionSpec];
	}

	if (!(options.hasOwnProperty("savedPuvSpecAttributes") || options.hasOwnProperty("savedCustomSpecAttributes")) && productData.fillByAI && productData.specification) {
		specsDataToSend = typeof productData.specification === 'string' ? JSON.parse(productData.specification) : productData.specification;
	}
	let specBrandName = specsDataToSend.find((cur)=> cur.sid == 122 && cur.values.length)
	specBrandName = specBrandName?.values[0] || '';
	let complianceSpecsFieldsName = productData.isTempProd || productData.isTemplate ? [] : ['manufacturer','manufactured_details','importer','importers_detail'];
	if(productData.isTempProd || productData.isTemplate){
		if(!productData.compliance?.manufacturer){
			complianceSpecsFieldsName.push('manufacturer');
		}
		if(!productData.compliance?.manufactured_details){
			complianceSpecsFieldsName.push('manufactured_details');
		}
		if(!productData.compliance?.importer){
			complianceSpecsFieldsName.push('importer');
		}
		if(!productData.compliance?.importers_detail){
			complianceSpecsFieldsName.push('importers_detail');
		}
	}
	let complianceSpecsFieldsArr = specsDataToSend.filter((cur)=> complianceSpecsFieldsName.indexOf(cur.name) != -1);
	let smartFillBrandData =  specsDataToSend.find((cur)=> cur.name == 'brand');
	specsDataToSend = JSON.stringify(specsDataToSend);
	description = formatProdDesc(description);
	let label_image = '';
	let label_front_image = ''
	label_image = getImageUrlLabel(productData?.label_image,productData);
	if(!label_image) {
		label_image = productData.labelImageUrl?productData.labelImageUrl:productData.ApprovedLabelImageUrl;
	}
	label_front_image = getImageUrlLabel(productData?.label_front_image,productData);
	let productOrService = productData.categoryType ? productData.categoryType : selectedCategoryType;
	let priceObj = {...productData.priceObj};
	if(productOrService == 'service' && options.hasOwnProperty('toggleIndex') && options.toggleIndex == 1) {
		if(priceObj.actualPrice && !priceObj.singlePrice) {
			priceObj.singlePrice = priceObj.actualPrice;
		}else if(priceObj.singlePrice && !priceObj.actualPrice) {
			priceObj.actualPrice = priceObj.singlePrice;
		}
	}
	if ((productOrService === 'service' || !productData.isSellOnline) && options.hasOwnProperty('toggleIndex')) {
		priceObj.isSinglePrice = false
		switch (options.toggleIndex) {
			case 1:
				priceObj.maxPrice = '';
				priceObj.minPrice = '';
				priceObj.max_price = '';
				priceObj.min_price = '';
				priceObj.isSinglePrice = true;
				break;
			case 3:
				priceObj.maxPrice = '';
				priceObj.minPrice = '';
				priceObj.max_price = '';
				priceObj.min_price = '';
				break;
			case 2:
				priceObj.singlePrice = '';
				priceObj.actualPrice = '';
				break;
		}
	}
	let data = {
		productName: productData.productName,
		imageUrl: (productData.isTempProd || productData.isTemplate) && productData.showUpload === 0 ? '' : finalImageUrl.join(','),
		// videoUrl: JSON.stringify(finalVideoUrl),
		videoIdList: videoUrlIds,
		description,
		priceObj: JSON.stringify(productData.aiPriceObj || priceObj),
		//sellingPrice: productData.sellingPrice,
		minOrderQuantity: productData.minOrderQuantity,
		unitOfMeasurement: productData.unitOfMeasurement,
		contentPerPiece: parseInt(productData.contentPerPiece) || options.contentWeightUnitSaved && options.contentWeightUnitSaved.hasOwnProperty("contentPerPiece") ? options.contentWeightUnitSaved?.contentPerPiece?.value.toString() : "" ,
		unitPerPiece: parseInt(productData.contentPerPiece) ? productData.unitPerPiece : options.contentWeightUnitSaved && options.contentWeightUnitSaved.hasOwnProperty("unitPerPiece") ? getMatchedUOM(state.uom.netweightUOM, options.contentWeightUnitSaved.unitPerPiece.value.toString()).val : "",
		categoryName: (productData.isTempProd )  && productData.productId == 'ADD_PRODUCT'? productData.psv_node_name:(productData.categoryName ? productData.categoryName : productData.psv_node_name) || '',
		leafId: productData.leafId == 0 && productData.isTempProd?productData.psv_node_id:productData.leafId,
		keywordId: productData.keywordId,
		custAttributes: JSON.stringify(customAttrs),
		attachmentData: JSON.stringify(attachmentData),
		isSellOnline : productData.isSellOnline?1:'',
		quantity : sellOnlineQuantity,
		mrp : productData.isSellOnline && productData.mrp ? Number(productData.mrp?.toString()?.replaceAll(',','')) : '',
		barcode : productData.barcode ? productData.barcode : '',
		sellingPrice : productData.isSellOnline && productData.sellingOnlinePrice ? Number(productData.sellingOnlinePrice?.toString()?.replaceAll(',','')) : '',
		parentId: (productData.isTempProd) ? productData.parentId : null,
		specification: specsDataToSend,
		brandName: specBrandName && !(productData.isTempProd || productData.isTemplate)? specBrandName : productData.brand ? productData.brand : '',
		sku: productData.sku?productData.sku:'',
		keywordName: productData.keywordName?productData.keywordName:'',
		consignment_no_display: productData.newconsignmentNo? productData.newconsignmentNo: '',
		label_image: label_image,
		label_front_image : label_front_image,
		isActive:Number(productData.visibility),
		descType: description?.length ? productData.descType : null,
		logId: productData?.aiLogId || '',
		priceLogId: productData?.priceLogId || ''
	};
	if (isCorrector){
		if (data.mrp && !data.sellingPrice){
			data.sellingPrice = data.mrp
		}
	}

	if(productOrService == 'service' || !productData.isSellOnline) {
		delete data.mrp;
	}

	if (state.session?.viaOmni) {
		// handling for omni
		data = {
			...data,
			// related  to stock reorder
			associatedSuppliers: Array.isArray(productData?.associatedSuppliers) ? productData.associatedSuppliers.join() : '',
			isAutoReorderLevel: !!productData?.isAutoReorderLevel,
			isAutoReorderQuantity: !!productData?.isAutoReorderQuantity,
			reorderLevel: productData?.reorderLevel || 0,
			reorderQuantity: productData?.reorderQuantity || 0,
			isPrescriptionRequired: productData?.isPrescriptionRequired ? true : false,
			// related to display category
			productGroupBreadCrumbList: productData?.productGroupBreadCrumbList ? productData.productGroupBreadCrumbList.toString() : '',
			selectedProductGroupIds: productData?.selectedProductGroupIds || 0,
			productGroup: productData?.productGroup || 0,
			enquiryFormId: productData?.enquiryFormId,
			outletWiseDeliveryList: productData?.outletWiseDeliveryList ? productData.outletWiseDeliveryList : [],
			outletWiseDeliveryListJson: productData?.outletWiseDeliveryList ? JSON.stringify(productData.outletWiseDeliveryList) : null,
			accountMongoId: productData?.accountMongoId || '',
			
			newcostPrice: productData?.cost_price || '',
			sizeChartId: productData?.sizeChartId,
			sizeChartName: productData?.sizeChartName,
			bulkPricingDetail: JSON.stringify(productData?.bulkPricingDetail),
			isBulkPricingActive: productData?.isBulkPricingActive ? 1 : 0,
			pBrandName: productData.pBrandName,
			maxSupplyCapacity: productData.maxSupplyCapacity,
			supplyTimePeriod: productData.supplyTimePeriod,
			brandName: productData?.brandName || '',
			manufacturerName: productData?.manufacturerName || '',
			manufacturing_date_flag: productData.expiryBy == 'manufacturing_date' ? 1 : 0,
			actualProductWeight: Number(productData?.actualProductWeight) >= 0.01 ? Number(productData.actualProductWeight) : '',
			productLength: productData?.productLength || '',
			productWidth: productData?.productWidth || '',
			productHeight: productData?.productHeight || ''
		}
	}


	if(['stds','Sess','Visit'].includes(productData.unitOfMeasurement) && ((productData.categoryType === 'service'|| productData.type === "SERVICE") || productOrService == 'service')){
		const unit = productData.unitOfMeasurement == 'stds' ? (productData?.specificDurationUnit || 'months') : productData.unitcount;
		data.unitOfMeasurement = productData.unitOfMeasurement == 'stds' ? (productData.specificDuration || 1) + ' ' + unit : unit;
	}
	if(productData.mrp_images || productId != 'ADD_PRODUCT'){
		data.mrp_images = productData.mrp_images || ''
	}
	if(productData.mrp_front_img || productId != 'ADD_PRODUCT'){
		data.mrp_front_img = productData.mrp_front_img || ''
	}
	if (productData.best_before) {
		let finalBestBeforeVal = (productData.best_before) ? productData.best_before + '-' + (productData.bestBeforeUnit?productData['bestBeforeUnit']:'months') : '';
		if (finalBestBeforeVal != '' && productData.expiryBy != 'expiryDate') {
			data.best_before = finalBestBeforeVal;
		}
	}else {
		data.best_before = '';
	}
	function formatDate(date) {
        if (date && date.toString().indexOf("/") > -1) {
            var strDate = date.split("/");
            return [strDate[2], strDate[1], strDate[0]].join('-');
        } else {
            return null;
        }
    }
	data.manufacturing_date_flag =  productData.expiryBy == 'manufacturing_date' ? 0 : 1;
	if (productData['manufacturing_date'] && productData.expiryBy == 'manufacturing_date') {
		let manufDate = productData['manufacturing_date'];
		data['manufacturing_date'] = formatDate(manufDate);
		data['expiry_date'] = '';
	}
	if(productData['expiry_date']) {
		if (productData.expiryBy == 'manufacturing_date' && productData.best_before) {
			data['expiry_date'] = '';
		}else {
			data['expiry_date'] = formatDate(productData['expiry_date']);
			data['best_before'] = '';
		}
	}
	if (productData.commissionRate) {
		data.commissionPerc = productData.commissionRate;
		if (!data.isSellOnline) {
			data.commissionPerc = null;
		}
	}
	if (productData.categoryType || selectedCategoryType) {
		data.categoryType = productData.categoryType ? productData.categoryType : selectedCategoryType;
	}
	const contractorTypes = ["CONTRACTORV2", "CONTRACTORV3"];
	let isContractor = state.session && state.session.user && state.session.user.loggedUser && (contractorTypes.indexOf(state.session.user.loggedUser.subType) != -1);
	if (isContractor && productData.cv2ProductSource) {
		data.cv2ProductSource = productData.cv2ProductSource;
	}
	//Add approval pending and deletion pending flag
	if (productData.attributes) {
		let returnObj = filterCatAttributes(productData.attributes)
		data.attributes = JSON.stringify(returnObj);
	}
	data.countryOrigin = [];
	if(productData.hsnSacNo && data.isSellOnline){
		data.hsnsacNo = productData.hsnSacNo;
	}
	if(productData.gstRate && String(productData.gstCess) && data.isSellOnline){
		data.gstRate = productData.gstRate;
		data.gstCess = productData.gstCess;
	}
	if(productData?.purchaseTax && data.isSellOnline && viaOmni){
		data.purchaseTax = JSON.stringify(productData.purchaseTax);	
	}
	if(productData?.productSynonym && viaOmni){
		data.productSynonym = productData.productSynonym;	
	}
	if (productData.countryOrigin && Object.keys(productData.countryOrigin).length) {
		let countrySpec = state.productSpecification.editablePuvSpecAttributes.find(el => el.s_nm == 'country_of_origin');
		if(countrySpec){
			countrySpec['userInput']['value'] = productData.countryOrigin.values[0];
			let specToSend = getAllSpecificationData([countrySpec],[],true);
			console.log(specToSend);
			let specs = JSON.parse(data.specification);
			specs.push(specToSend[0]);
			if((!productData.isTempProd && !productData.isTemplate) || (!productData.compliance?.country_of_origin)){
				complianceSpecsFieldsArr.push(specToSend[0]);
			}
			specs = specs.filter(cur => {
				if(productData.countryOrigin.values[0].toLowerCase() == 'india' && [193803,110653].includes(Number(cur.sid))){
					return false;
				}
				if(cur && !((state.brandManufacturer.fixedSpecs.size || !Array.isArray(state.brandManufacturer.fixedSpecs) ?state.brandManufacturer.fixedSpecs.has(cur.sid?.toString()):state.brandManufacturer?.fixedSpecs?.includes(cur.sid?.toString())))) {
					return cur;
				}
			})
			console.log('specs::: ',specs)
			data.specification = JSON.stringify(specs);
		}
		// let countryOrigin = { ...productData.countryOrigin };
		// data.countryOrigin.push(countryOrigin);
		// data.countryOrigin = JSON.stringify(data.countryOrigin);
	}
	let url = '';
	const bizSuggestion = state.products.editProduct.bizSuggestion
	
	let alreadySelected = state.session.businessType;
	bizSuggestion.natCatId = bizSuggestion.bizType ? bizSuggestion.bizType : alreadySelected;
	let selectedList = [];
	if (''!=bizSuggestion.natCatId) {		
		selectedList = [{bizType: bizSuggestion.natCatId, natCatId: bizSuggestion.natCatId.split(',').length==1 ? bizSuggestion.natCatId : '1111'}];
	} 
	
	if(productData.productId == 'ADD_PRODUCT' && productData.isTempProd && productData.businessType){
		selectedList = [{bizType: productData.businessType,natCatId: '1111'}];
	}
	if(state.products.tabKey == 'brand' && productData.type == "SERVICE"){
		selectedList = [{bizType:"Service"}]
	}
	const flowCheck = identifyAuditFlow({checkType: true});
	let isSpecialContract = flowCheck.isSpecialContract;
	if (productId == 'ADD_PRODUCT') {
		if (isSpecialContract) {
			let auditData = getAuditorData({ state });
			data = {
				...data,
				token: getSearchToken({
					token: state.session.token
				}),
				auditData: JSON.stringify(auditData),
				generic_p_id: productData.generic_p_id
			}
		} else {
			data = {
				...data,
				token: state.session.token,
				generic_p_id: productData.generic_p_id
			}
		}
		if (!data.leafId && data.categoryName) {
			//If Category name is there but no leafId, its a custom category.
			data.suggestedCategoryName = data.categoryName;
			data.leafId = '';
			data.categoryName = '';
			data.categoryComment = productData.categoryComment;
		}
		url = '/vendorapis/products/unifiedproduct/addproduct?' + 'bizTypeData=' + JSON.stringify(selectedList)

	} else {
		let auditData = getAuditorData({ state });
		let tempProductId = productData.isObjectionable ? objectionalKeyHandling({ id: productData.id, key: 'REPLACE', value: productId }) : productId;
		let isReviewStatusRejected = productData.reviewStatus?.split(',').includes('REJECTED');
		data = {
			...data,
			productId: tempProductId,
			token: state.session.token,
			isAuditUrl: isReviewStatusRejected ? null : auditData.isAuditUrl,
			auditData: isReviewStatusRejected ? null :  JSON.stringify(auditData),
			timestamp: productData.audtTimeStamp,
			saveRejectedViaAudit: auditData.isAuditUrl && isReviewStatusRejected
		}
		if (productData.suggestedCategoryName) {
			//user has edited a product with a custom category
			if (productData.leafId) {
				//user has replaced custom with regular category
				data.suggestedCategoryName = '';
				data.categoryComment = '';
			} else {
				data.suggestedCategoryName = (productData.categoryName || productData.suggestedCategoryName);
				data.categoryName = '';
				data.categoryComment = productData.categoryComment;
			}
		} else if (!data.leafId && data.categoryName) {
			//User has replaced regular category with custom category
			data.suggestedCategoryName = data.categoryName;
			data.leafId = '';
			data.categoryName = '';
			data.categoryComment = productData.categoryComment;
		}
		if (productData.isObjectionable) {
			data.id = productData.id;
			let { queueType = '' } = identifyAuditFlow({ query: true });
			url = '/marketplace/static/php/web/b2bWebsite.php?action=updateObjectionableProduct';
			if (flowCheck.fetchNextAudit) {
				url += `&isAuditUrl=true&queueType=${queueType}`;
			}
			if (flowCheck.searchAudit) {
				url += `&isSearchAudit=true`;
			}
			url += `&bizTypeData=${JSON.stringify(selectedList)}`;
		}else if (options.rejectionCheck){
			url = `/marketplace/static/php/web/b2bWebsite.php?action=addRejectionAuditData&sourceId=`
		} else {
			url = '/vendorapis/products/unifiedproduct/updateProduct?' + 'bizTypeData=' + JSON.stringify(selectedList);
		}
	}
	if (!options.rejectionCheck && options.isSaveForceFully) {
		url += `&saveObjectionable=true`;
	}
	if(state.session.user?.loggedUser && state.session.user?.loggedUser?.userType == 'AUDITOR' && state.session.user?.loggedUser?.subType == "CORRECTOR"){
		url += `&auditQueueType=corrector`
	}
	let jdMartParams = getJdMartParams();
    if (!options.rejectionCheck){
		url += `&sourceId=${jdMartParams.sourceId ? jdMartParams.sourceId : ''}`;
	}
	if(genericId) {
		url += '&isGeneric=1&genericId='+genericId;
	}
	if(!viaOmni) {
		url += `&viaOmni=false`;
	}
	
	if (!state.session?.viaOmni && productData.generic_product && state.products.tabKey == "brand"){
		data.genericId = productData.id
	} else if (state.products.showCategoryMissingCardPersist) {
		url = url + '&smartCardSource=ADD_CATEGORY';		
	} else if (state.products.actionCardFilter?.type) {
		let cardType = ''; 
		switch(state.products.actionCardFilter?.type) {
			case "descMissingCount":
				cardType = 'ADD_DESC';
			break;
			case "specMissingCount":
				cardType = 'ADD_SPEC';
			break;
			case "imgMissingCoun":
				cardType = 'ADD_IMAGE';
			break;
			case "rejectedCount":
				cardType = 'FIX_REJECTED';
			break;
			case "scoreLessThanHundred":
				cardType = 'LOW_SCORE';
			break;
		}
		url = cardType ? url + '&smartCardSource='+cardType : url;	
	}
	
	const isMobile = state.library.deviceData.isMobile;
	isMobile && dispatch({
		type: RESET_LISTING_DATA
	});

	let isVariantAvailable = state.variants.variantProductData?.length;
	data.unitOfMeasurement = isVariantAvailable && productData.categoryType == 'service' ? '' : data.unitOfMeasurement;
	if(!options.rejectionCheck && isVariantAvailable) {
		let variantToSend = formVariantData(productData,state,data.categoryType,viaOmni);
		data.variantJson = variantToSend.variantJson,
		data.variantsInventoryJson = variantToSend.variantsInventoryJson
	}
	let isAuditor = state.session?.user?.loggedUser?.userType == "AUDITOR" && flowCheck.fetchNextAudit;
	if (!options.rejectionCheck && isAuditor && productData.isTemplate) {
		let ownerUpdatedData = [];
		if (Array.isArray(state.products.auditorBrandedLog)) {
			ownerUpdatedData = state.products.auditorBrandedLog;
		} else {
			ownerUpdatedData = [state.products.auditorBrandedLog];
		}
		data.ownerUpdatedData = JSON.stringify(ownerUpdatedData);
	}
	if (options.rejectionCheck) {
		let auditData = getAuditorData({ state });
		let tempProductId = productData.isObjectionable ? objectionalKeyHandling({ id: productData.id, key: 'REPLACE', value: productId }) : productId;
		let isReviewStatusRejected = productData.reviewStatus?.split(',').includes('REJECTED');
		data = {
		productId: tempProductId,
		token: state.session.token,
		isAuditUrl: isReviewStatusRejected ? null : auditData.isAuditUrl,
		auditData: isReviewStatusRejected ? null :  JSON.stringify(auditData),
		timestamp: productData.audtTimeStamp,
		saveRejectedViaAudit: auditData.isAuditUrl && isReviewStatusRejected
	}
	}
	if(!viaOmni) {
		delete data.manufacturing_date_flag;
	}
	if (viaOmni){
		delete data.viaOmni
	}
	if (data.specification && payload?.orgSpex){
		let showCorrectionModal = payload?.isSame;
		if (payload.isSame){
			let editedSpex = JSON.parse(data.specification);
			if (editedSpex.length !== payload.orgSpex.length){
				showCorrectionModal = false;
			}
			for(let index = 0;index < editedSpex.length;index ++) {
				let element = payload.orgSpex.find(ele => (ele.name == (editedSpex[index].s_name || editedSpex[index].name) || ele?.displayName == (editedSpex[index].s_name || editedSpex[index].name)));	
				if(!element || (JSON.stringify(element.value) != JSON.stringify(editedSpex[index].values))) {
					showCorrectionModal = false;
					break;
				}
			}
			if (showCorrectionModal){
				cb && cb( {
					isSuccess : false,
					showCorrectionModal
				})
				return
			}
		}
	}
	if (!options.rejectionCheck) {
		data = replaceMultipleSpaces(data);	
	}
	data = queryString.stringify(data);
	axios
		.post(url, data)
		.then(async res => {
			let prodId = res.data?.data?.productId?res.data.data.productId:productData.productId;
			if (res.data.status == 1) {
				if(productData.addInventoryBatch && productData.productId==='ADD_PRODUCT'){
					const params = {
						token:  state.session.token,
						productId: prodId ,
						action: 'updateInventorybatch'
					};
					if(state.session?.viaOmni){
						params.viaOmni = 1
					}
					axios.post('/marketplace/static/php/web/b2bWebsite.php', productData.addInventoryBatch,
						{
						params,
						headers: {
							"Content-Type": "application/json"
						},
						}
					)
						.then((res) => {
							console.log('Batch added');
						});
				}
				if(prodId && prodId !== 'ADD_PRODUCT' && !isAuditor){
					if(productData.isSellOnline){
						let docreqData = await axios.get(`/vendorapis/products/inventory/getRejectionReason?productid=${prodId}`)
						if(docreqData.data.data?.length){
						   res.data.docrequiredData = docreqData.data.data
						}else if(docreqData.data?.is_audit_pending){
							res.data.auditPendingModal = true;;
						}
					}
					let catId = productData.leafId?productData.leafId:'';
					let countFormData = {
						supplierId : state.session.supplierId,
						category : catId,
						brand: specBrandName || productData.brand || productData.brandName
					};
					countFormData = queryString.stringify(countFormData);
					let countData = await axios.post(`/vendorapis/products/ajax/getSmartFillCount`,countFormData);
					if(countData.data.count > 0){
						let formattedComplianceArr = [...complianceSpecsFieldsArr];
						if(!productData.isTemplate && !productData.isTempProd){
							formattedComplianceArr.push(smartFillBrandData);
						}
						formattedComplianceArr.forEach((cur)=>{
							if(cur){
								cur['value'] = cur.values[0];
								delete cur.values;
							}
						})
						dispatch({
							type: SET_SMART_FILL_DATA,
							payload: {
								data: {
									complianceArr: formattedComplianceArr,
									catId:
										productData.leafId == 0 && productData.isTempProd
											? productData.psv_node_id
											: productData.leafId,
									categoryName:
										productData.categoryName || productData.psv_node_name ||
										productData.suggestedCategoryName || productData.category || productData.catName,
									count: countData.data.count,
									brand: specBrandName || productData.brand || productData.brandName
								}
							}
						});
						res.data.smartComplianceData = {
							show: true
						}
					}
				}
				const response = {
					isSuccess: true,
					data: res.data
				}
				if (res.data.isFirstProduct && [23].includes(state.session.jdSource)) {
					notifyCatalogueCreated();
				}
				if (!options.rejectionCheck){
      				const remainingVendorImages = vendorImages.length - imagesToDeleteFromGallery.length;
					dispatch(deleteVendorImages({
						imagesToDelete: imagesToDeleteFromGallery,
						supplierId: state.session.supplierId
					}))
					if (!remainingVendorImages && imagesToDeleteFromGallery.length) {
						response.redirectToListing = true;
					}
					dispatch(setSelectedGalleryImages([]));
					if (productId == 'ADD_PRODUCT' || productData.isObjectionable) {
						productId = res.data.data.productId
					}
				}

				if( tabKey!= 'objectionable' && ((tabKey != 'auditPending' && listingProdData.prodCount <= 1) || (res.data.msg && (res.data.msg == "objectionable content found")))){
					dispatch(setTabStatus({ tabKey: undefined }));
					dispatch(setPreviousTabIndex({tabIndex: 0}));
				}else{
					if(state?.products?.search?.searchTab == 'brand' && state.products.tabKey == 'brand'){
						dispatch(setTabStatus({ tabKey: 'brand' }));
						response.tabKey = 'brand';
					}else {
						dispatch(setTabStatus({ tabKey: tabKey }));
						dispatch(setPreviousTabIndex({tabIndex: tabIndex}));
						response.tabKey = tabKey;
					}
				}
				if(state.session.isShopVirtual) {
					try {
						axios.get('/marketplace/static/php/web/walkThroughApi.php?action=updateStatus&supplierId='+state.session.supplierId).then(res => {
							if(!res.data.isSuccess){
								console.log('UpdateWalkThrough response : ',res.data);
							}
						}).catch(err => {
							console.log('Error in updateWalkthrough API , ',err)
						})
					}catch(err) {
						console.log('Cannot call updateWalkthrough API properly , ',err);
					}
				}
				cb && cb(response,tabKey);
				dispatch({
					type: SAVE_ADD_EDIT_PRODUCT,
					payload: {
						...payload,
						productId
					}
				});
				if(!state.products.isSearchSliderOpen) {
					dispatch({
						type: 'SET_LISTING_DATA',
						payload: {
							forShimmer: true,
							showShimmer: true,
							currentPage: 0
						}})		
						if (state?.products?.search?.searchTab != 'brand') {
								window.scrollTo(0, 0);
						}
				}
				dispatch(getListingData({
					pageNo: 1,
					supplierId: state.session.supplierId,
					tabKey,
					finalPageNo: tabKey == state.products.tabKey ? state.products.listing.currentPage : 1,
					filterObj: state.products.listing.filterObj,
					cb: () => {
						if(state?.products?.search?.searchTab != 'brand' && state.products.tabKey == 'brand'){
							dispatch(setTabStatus({ tabKey: undefined }));
							dispatch(setPreviousTabIndex({tabIndex: 0}));
						}
					}
				}));
			} else if (res.data.status == 0) {
				let response = {
					isSuccess: true
				};
				if (res.data.isAlreadyAudited) {
					response.isAlreadyAudited = true;
					cb && cb(response);
				} else if (res.data.isOwnerEdited) {
					response.isOwnerEdited = true;
					cb && cb(response);
				} else if (res.data.duplicateProduct) {
					response.duplicateProduct = true;
					response.msg = res.data.msg;
					cb && cb(response);
				} else if (res.data.msg && (res.data.msg == "objectionable content found")) {
					res.data.status = 1;
					cb && cb({
						isSuccess: true,
						data: res.data
					});
				} else if (res.data?.irrelevantContent) {
					cb && cb({
						isSuccess: false,
						data: res.data
					});
				} else if(res.data.msg == 'Invalid Branded ProductId'){
					response.invalidBrandedId = true;
					cb && cb(response);
				} else if(res.data.msg == 'Empty image Url'){
					response.emptyImage = true;
					cb && cb(response);
				}else if(res.data.msg && ((res.data.msg.toLowerCase()) == 'hard category found')){
					response.multiPercentIssue = true
					response.msg = res.data.msg
					response.isSuccess = false
					cb && cb(response)
				}else if(res.data.msg && res.data.msg.toLowerCase() == 'empty businesstype') {
					response.msg = res.data.msg;
					response.businessError = true;
					response.isSuccess = false;
					cb && cb(response);
				}else if(res.data.msg && res.data.msg.toLowerCase() == 'keyword not active') {
					cb && cb({
						isSuccess: false,
						data: res.data
					});
				}
			} else if (res.data.status == 2) {
				cb && cb({
					isSuccess: true,
					data: res.data
				});
			} else if (res.data.status == 3) {
				cb && cb({
					isSuccess : true,
					data : res.data
				})
			} else if(res.data?.isError) {
				cb && cb({
					isSuccess: false,
					data: res.data
				});
			}
		});
};

export const auditorRejection = ()=> async (dispatch,getState)=>
{
	const state = getState();
	const productData = state.products.editProduct;
	let productId = productData.productId;
	const rejectUrl = `/marketplace/static/php/web/b2bWebsite.php?action=addRejectionAuditData&sourceId=`
	let auditData = getAuditorData({ state });


	let tempProductId = productData.isObjectionable ? objectionalKeyHandling({ id: productData.id, key: 'REPLACE', value: productId }) : productId;
	let isReviewStatusRejected = productData.reviewStatus?.split(',').includes('REJECTED');
	let data = {
		productId: tempProductId,
		token: state.session.token,
		isAuditUrl: isReviewStatusRejected ? null : auditData.isAuditUrl,
		auditData: isReviewStatusRejected ? null :  JSON.stringify(auditData),
		timestamp: productData.audtTimeStamp,
		saveRejectedViaAudit: auditData.isAuditUrl && isReviewStatusRejected
	}
	data = queryString.stringify(data);
	const rejectData = await axios.post(rejectUrl,data)
	let respObj = {}
	if (rejectData.status = 200) {
		return rejectData
	}else {
		return 'error'
	}


};
export const checkIfCategoryExists = (catName, token, cb) => {
	axios
		.get('/marketplace/static/php/web/b2bWebsite.php?action=autosuggest&str=' + catName + '&token=' + token)
		.then(res => {
			if (res.data.isSuccess && res.data.data.length) {
				let catFound = false;
				res.data.data.map((category) => {
					if (category.name.toLowerCase() == catName.trim().toLowerCase()) {
						catFound = true;
					}
				});
				cb(catFound);
			} else {
				cb(false);
			}
		})
}

export const resetProductData = payload => ({
	type: RESET_PRODUCT_DATA,
	payload
});

export const fetchPsvInfo = (payload,cb) => async (dispatch, getState ) => {
	const state =  getState()
	const token = state.session.token;
	const supplierId = state.session.supplierId;
	let url = `/vendorapis/products/ajax/getPsvInfo?token=${token}&supplierId=${supplierId}`
	axios.get(url).then(data=>{
		dispatch({
				type: SETPSVINFODATA,
				data: data.data,
				mainUOM: state.uom
			})
	}).catch(err=> {
		console.log('err from psvInfo',err);
	})
}

export const getPsvDetails = (product,cb) => (dispatch,getState) => {
	const state = getState();
	const psvData = product.type == "product" ?  state.products.psvInfoData.productUom : state.products.psvInfoData.serviceUom;
	const psvObj = psvData && psvData.find(x => Number(x?.PSV_NODE_ID) === Number(product?.psv_node_id))
	return psvObj ? psvObj : null;
}

export const getBizList = (payload, cb) => async (
	dispatch,
	getState
) => {
	// const state = getState();
	// axios
		// .get("/marketplace/static/php/web/b2bWebsite.php?action=getBizTypeList&leafId=" + (payload ? payload : '') + "&token=" + state.session.token)
		// .then(res => {
			dispatch({
				type: GET_BIZ,
				payload
			})
		// })
		// .catch(err => console.error(err));
}

export const updateBizList = payload => async (
	dispatch
) => {
	dispatch({
		type: UPDATE_BIZ,
		payload
	}
	)
}
export const toggleBiz = payload => async (
	dispatch
) => {
	dispatch({
		type: TOGGLE_BIZ,
		payload
	})
}

export const getVendorProducts = ({
	pageNo = 1,
	filterObj = {},
	isSearch,
	searchText,
	orderBy = "",
	isSelectProdSlider
}) => async (dispatch, getState) => {
	let res;
	let listingData = {};
	let strUrl = `${apiDomain}/marketplace/products/services/listing.service?reviewState=allProducts&status=ACTIVE&company=&pageNumber=${pageNo}&newListing=true`;
	if (isSearch) {
		strUrl = strUrl + `&searchKeywords=${searchText}`;
	}
	if (orderBy === "image") {
		strUrl += '&orderByImage=true'
	}
	Object.keys(filterObj).map(key => {
		strUrl += `&${key}=${encodeURIComponent(filterObj[key].join('#@#'))}`;
	});
	res = await axios.get(strUrl);
	listingData = {
		productData: res.data.page.results.length ? formatVendorData(res.data.page.results) : [],
		...res.data.page,
		currentPage: pageNo,
		filterObj,
		isReset: !pageNo,
		searchQuery: searchText
	};
	let productList = listingData.productData || [];
	productList.map(cur => {
		if (['0', '0.0', '0.00'].indexOf(cur.sellingPrice) > -1) {
			cur.sellingPrice = '';
		}

		return (cur.imageUrlArr = formatMediaUrl(cur.imageUrl, cur.videoUrl, false));
	});
	let type = SET_LISTING_DATA;
	if (isSearch) {
		type = SET_SEARCH_DATA
	} else if (isSelectProdSlider) {
		type = SET_PRODUCT_SLIDER_DATA
	}
	dispatch({
		type: type,
		payload: listingData
	});
}

export const setBrandSuggestion = payload => async(dispatch) => {
	dispatch({
		type: SET_BRAND_SUGGESTION,
		payload
	})
}

export const toggleProductVisibility = payload => async (
	dispatch, getState
) => {
	var status;
	var tabKey = getState().products.tabKey;
	if(payload.hiddenVariantCount){
		status = payload.hiddenVariantCount > 0 ? '1':'0';
	}
	else{
		status = !payload.visibility ? '0' : '1';
	}
	let strUrl = `/vendorapis/products/website/changeProductStatus?productId=${payload.pidList || payload.productId}&visibility=${status}&token=${payload.token}`;
	if(payload.status == 'APPROVAL_PENDING'){
		strUrl += `&isShadow=1`;
	}
	const state = getState();
	const tmpObj = {}
	if(state?.products?.search?.searchQuery){
		tmpObj.isSearch = true;
		tmpObj.searchText = state?.products?.search?.searchQuery
	}
	axios.get(strUrl).then(dispatch(getListingData({...tmpObj,tabKey})));
	// dispatch({
	// 	type: TOGGLE_PRODUCT_VISIBILITY,
	// 	payload
	// })
}

export const setProductSpecification = payload => {
	return {
		type: SET_PRODUCT_SPECIFICATION,
		payload
	}
}

export const setFileAttachmentData = payload => {
	return {
		type: SET_ATTACHMENT_DATA,
		payload
	}
}

export const resetFileAttachmentData = payload => {
	return {
		type: RESET_FILE_ATTACHMENT_DATA,
		payload
	}
}

export const deleteAttachmentFile = payload => {
	return {
		type: DELETE_ATTACHMENT_FILE,
		payload
	}
}

export const toggleEditDisplayNameModal = payload => ({
	type: TOGGLE_EDIT_DISPLAYNAME_MODAL,
	payload
});


export const renameAttachmentFile = payload => {
	return {
		type: RENAME_PRODUCT_ATTACHMENT,
		payload
	}
}

export const toggleViewFileDetailsSlider = payload => {
	return {
		type: VIEW_FILE_DETAILS_SLIDER,
		payload
	}
}

export const toggleFileProgressBar = payload => {
	return {
		type: TOGGLE_FILE_PROGRESS_BAR,
		payload
	}
}

export const cancelPendingFiles = payload => {
	return {
		type: CANCEL_PENDING_FILES,
		payload
	}
}

export const markPreviouslyUploadedFiles = payload => {
	return {
		type: MARK_PREVIOUSLY_UPLOADED_FILES,
		payload
	}
}

export const updateProductStatus = payload => async (dispatch) => {
	let url = `${apiDomain}/marketplace/static/php/web/b2bWebsite.php?&action=approveProducts&token=${payload.token}&productIdList=${payload.productId}`;
	if (payload.action == 'delete') {
		url = `/marketplace/static/php/web/b2bWebsite.php?&action=deletionApproval&token=${payload.token}&productIdList=${payload.productId}&isDelete=${payload.isDelete}`;
	}else{
		if(payload.isAllSelected){
			url += `&selectAll=1`;
		}
	}
	let jdMartParams = getJdMartParams();
	url += `&sourceId=${jdMartParams.sourceId ? jdMartParams.sourceId : ''}`;
	let res = await axios.post(url);
	if (res.data && res.data.status == 1) {
		payload.cb(res.data.isLastProductApproved,res.data)
	}
}

export const matchLowestPrice = payload => async (dispatch, getState) => {
	const state = getState();
	let url = `${apiDomain}/vendorapis/products/product/updateProductSP?supplierId=${state.session.supplierId}&productId=${payload.productId}&selling_price=${payload.price}`;
	let res = await axios.post(url);
	if (res.data && res.data.results == "Consignment Updated Successfuly") {
		dispatch({
			type: UPDATE_PRODUCT_SELLING_PRICE,
			payload: {
				price: payload.price,
				productId: payload.productId
			  }
		});
		payload.cb()
	}
}

export const setAuditObject = payload => {
	return {
		type: SET_AUDIT_OBJECT,
		payload
	};
};

export const toggleConfirmDelete = payload => {
	return {
		type: TOGGLE_CONFIRM_DELETE,
		payload
	};
}
export const toggleConfirmApprove = payload => {
	return {
		type: TOGGLE_CONFIRM_APPROVE,
		payload
	};
}
toggleConfirmApprove

export const toggleTab = payload => {
	return {
		type: TOGGLE_TAB,
		payload
	};
}
export const setRedirectedFrom = payload => {
	return {
		type: REDIRECTED_FROM,
		payload
	};
}
export const toggleInfoBox = payload => {
	return {
		type: TOGGLE_INFO_BOX,
		payload
	};
}

export const deleteProductFromList = variantId => {
	return {
		type: DELETE_PRODUCT,
		payload: {
			variantId: variantId
		}
	}
}

export const formatGalleryImage = (galleryImage, isJdPhotoSlider) => {
	galleryImage.imageUrl = galleryImage.imageUrl || galleryImage.img_path;
	const formattedImage = {
		...galleryImage,
		uploaded: true,
		actualPath: getImagePath(galleryImage.imageUrl),
		jdGalleryImage: !!isJdPhotoSlider,
		galleryId: galleryImage.id,
	}
	delete formattedImage.id
	return formattedImage
}

export const toggleEditOptions = payload => {
	return {
		type: SHOW_HIDE_EDIT_OPTION,
		payload
	}
}

export const getVendorImages = ({ supplierId, pageNo = 0, isJdPhotoSlider = false, token,productId, isEnrich = false, isAISlider = false, keywordId, curImageUrl = ''}) => async (dispatch, getState) => {
	let strUrl = `/vendorapis/products/image/getAllImagesForSupplier?supplierId=${supplierId}&pageNo=${pageNo}`;
	if (isJdPhotoSlider && !isAISlider) {
		strUrl = `/marketplace/static/php/web/b2bWebsite.php?action=getJdGalleryImages`;
	}else if(isAISlider && isJdPhotoSlider) {
		strUrl = `/marketplace/static/php/web/b2bWebsite.php?action=imageListing&pageNo=1&keyword_id=${keywordId}`
	}
	if (isEnrich) {
		strUrl += '&forEnrich=true';
	} else {
		if (isJdPhotoSlider) {
			strUrl += `&token=${token}`;
		}
	}
	if(productId && productId != 'ADD_PRODUCT' && !isAISlider){
		strUrl += '&productId='+productId;
	}

	const { data } = await axios.get(strUrl);
	const result = isAISlider ? data.results.filter(cur => !curImageUrl.includes(cur.img_path)) : data.data.concat(data.data);
	const newImgArr = (result || []).map((cur) => formatGalleryImage(cur, isJdPhotoSlider));
	console.log(newImgArr)
	dispatch({
		type: SET_VENDOR_IMAGES,
		payload: {
			imageArr: newImgArr,
			isJdPhotoSlider
		}
	});
}

export const getVendorObjectionableProducts = (pageNo = 1) => async (dispatch, getState) => {
	let strUrl = `/marketplace/static/php/web/b2bWebsite.php?action=listObjectionableProductsForVendor&pageNo=${pageNo}`;
	const state = getState();
	const { data } = await axios.get(strUrl);
	let productList = [];
	if (data.data) {
		if (pageNo > 1) {
			productList = [...state.products.vendorObjectionableProducts, ...data.data.productData];
		} else {
			productList = data.data.productData;
		}
	}
	if (productList.length) {
		productList = productList.map((cur) => {
			cur.variantId = cur.id;
			return cur;
		})
	}
	console.log(productList);
	dispatch({
		type: SET_VENDOR_OBJECTIONABLE_PRODUCTS,
		payload: productList
	});
	return productList.length;
}

export const deleteVendorImages = ({
	imagesToDelete = [],
	supplierId
}) => async (dispatch, getState) => {
	const curVendorImages = getState().products.vendorImages;
	const finalImageArr = Array.isArray(curVendorImages) && curVendorImages.length > 0 && curVendorImages.filter((cur) => {
		const isDeleted = imagesToDelete.includes(cur.galleryId);
		console.log(isDeleted, cur.galleryId);
		return !isDeleted
	});

	if (imagesToDelete.length) {
		axios.get(`/vendorapis/products/image/markImageAsInActive?supplierId=${supplierId}&imageIds=${imagesToDelete.join(",")}`)
	}
	dispatch({
		type: SET_VENDOR_IMAGES,
		payload: {
			imageArr: finalImageArr
		}
	})
}

// variantId
// imageUrlArr
export const uploadMultipleImages = (payload) => ({
	type: UPLOAD_MULTIPLE_IMAGES,
	payload
})

export const setVendorImages = (imageArr, isJdPhotoSlider = false) => {
	return ({
		type: SET_VENDOR_IMAGES,
		payload: {
			isJdPhotoSlider,
			imageArr
		}
	})
}

export const fetchCountryCode = () => async dispatch => {
	const res = await axios.get('/marketplace/getCountryCodes.ns');
	dispatch({
		type: INITIAL_COUNTRY_CODE,
		payload: {
			data: res.data.data
		}
	});
};

export const getAuditProductUpdateLog = ({
	supplierId,
	productId
}) => async dispatch => {
	let url = `/vendorapis/products/ajax/auditProductUpdateLog?supplierId=${supplierId}&productId=${productId}`;
	axios.get(url).then(({data}) => {
		dispatch({
			type: SET_AUDITOR_BRANDED_LOG,
			payload: {
				data: data.data
			}
		})
	});
};

export const fetchProductAndEdit = ({ productId, token, cb,isObjectionable =false, id}) => {
	return async dispatch => {
		await dispatch(getProductData({ productId, token,isObjectionable, id }));
		cb && cb();
	}
}


export const setHybridData = (payload) => async (
	dispatch,getState
) => {
	let sendData = [];
	let puvSpec = [];
	let state = getState();
	// let detailsSpecification = state.brandManufacturer.detailsSpecification;
	let {data,sidData,optionName} = payload;
	if(data) {
		Object.keys(data).map(cur => {
		  sendData.push({
			sid: sidData[cur],
			name: optionName && Object.keys(optionName).length?optionName[cur]:cur,
			values: data[cur]?[data[cur]]:[],
			isCustom: sidData[cur]?0:1
		  })
		  let eleInSpec = state.brandManufacturer.brandSpec.find(el => el.s_id == sidData[cur]);
		  if(eleInSpec){
			  eleInSpec.userInput.value = data[cur];
			  if(data[cur]){
				    eleInSpec.s_type = 'Fixed';
					eleInSpec.s_type_options = [data[cur]];
			  }
			  puvSpec.push(eleInSpec);
		  }else {
			  puvSpec.push({
				  s_id: sidData[cur],
				  s_nm: cur,
				  s_dnm: optionName && Object.keys(optionName).length?optionName[cur]:cur,
				  s_type: 'Textbox',
				  s_mandatory: '1',
				  userInput: {
					  value: data[cur],
					  error: ''
				  }
			  })
		  }
		})

		if(payload.smart){
			dispatch({
				type: UPDATE_SPECIFICATION_DATA,
				payload: {
					productSmartFillSpec: puvSpec
				}
			})
		}else{
			puvSpec = puvSpec.filter(el => !(['tax_rate','hsn'].includes(el.s_nm)));
			let editblePuv = [...state.productSpecification.editablePuvSpecAttributes];
			puvSpec = puvSpec.filter(el => !editblePuv.find(cur => cur.s_nm === el.s_nm));
			let customAttrs = [...state.productSpecification.savedCustomSpecAttributes];
			customAttrs = customAttrs.filter(el => !puvSpec.find(cur => cur.s_id == el.sid));
			let customAttrsObj = {};
			if(payload.categoryType == 'service'){
				customAttrsObj = {
					savedCustomSpecAttributes: [...customAttrs],
					initCustomSpecAttributes: [...customAttrs]
				}
			}

			if(!state?.productSpecification?.isEnrichSpec){
				dispatch({
					type: UPDATE_SPECIFICATION_DATA,
					payload: {
						editablePuvSpecAttributes: [...puvSpec,...editblePuv],
						savedPuvSpecAttributes: [...puvSpec,...editblePuv],
						...customAttrsObj
					}
				})
			}
		}
	}
		dispatch({
			type: SET_HYBRID_DATA,
			payload: {
				hybrid: sendData
			}
		})
}

export const setSearchByDocId = ({docIdSearch = false}) => {
	return async dispatch => {
		dispatch({
			type: SET_SEARCH_BY_DOC_ID,
			payload: {
				docIdSearch
			}
		})
	}
};

export const setFromSeller = ({fromSellerDashboard}) => {
	return async dispatch => {
		dispatch({
			type: SET_FROM_SELLER,
			payload: {
				fromSellerDashboard
			}
		})
	}
}

export const setPreviousTabIndex = ({tabIndex}) => {
	return async dispatch => {
		dispatch({
			type: SET_PREVIOUS_TAB_INDEX,
			payload: {
				tabIndex
			}
		})
	}
}


export const uploadAddEditMutlipleImages = payload => ({
	type: UPLOAD_IMAGE_FROM_ADD_EDIT,
	payload:{
		...payload,
		uploadType: 'MULTIPLE',
	}
})
const getUploadKeyIndex = (arr, key) => {
	var keyIndex = -1;
	keyIndex = arr.findIndex(cur => key === cur.imgIndex);
	return keyIndex;
};

const getVideoById = (id, videos = {}) => {
	let videoObj;
	if (videos[id]) {
		videoObj = videos[id]
	} else {
		id = Object.keys(videos).find(key => videos[key].imgIndex === id)
		videoObj = videos[id]
	}
	return videoObj
}

const getVideoUrlArr = (videoUrlIds, {
	videoLibrary
}) => {
	const {
		videos
	} = videoLibrary;
	const videoUrlArr = []
	if (!videoUrlIds) {
		return []
	}
	videoUrlIds.forEach((curId) => {
		let curVideoData = getVideoById(curId, videos);
		if (curVideoData) {
			curVideoData = { ...curVideoData };
			curVideoData.videoId = curId;
			videoUrlArr.push(curVideoData)
		}
	})
	return videoUrlArr;
}


export const updateProductMediaLocal = (state, payload, cb) => {
	const store = getStore();
	// PState means Parent State
	const PState = store.getState();
	if (payload.forVideo && payload.from !== 'Videogallery') {
		const { videoLibrary } = PState;
		let videoLinkedToVariant = true;
		if (payload.imageUrl.forUpload) {
			const curVideo = videoLibrary.videos[payload.imgIndex] || {};
			console.log(curVideo);
			const variantIdsToLink = [...curVideo.variantIdsToLink];
			if (!variantIdsToLink.includes(payload.productId)) {
				videoLinkedToVariant = false;
			}
		}
		updateVideoInLibrary({
			...payload.imageUrl,
			ignoreSave: payload.ignoreSave,
			editProductId: payload.editProductId,
			token: PState.session.token,
			fromImageViewSlider: true,
			newIdcb: (newId) => {
				cb({
					...state,
					videoUrlIds: [newId],
					videoUrlArr: getVideoUrlArr([newId], store.getState())
				});
			}
		})(store.dispatch, store.getState)
		if (!videoLinkedToVariant) {
			return;
		}
	} else if(payload.from === 'Videogallery'){
		store.dispatch({
			type: LINK_VIDEO_TO_PRODUCT_FROM_ADD_EDIT,
			payload: {
				...payload,
				editProductId: payload.productId || payload.editProductId
			}
		})
	}
	if(!payload.forVideo){
	if(payload.uploadType === 'MULTIPLE'){
		return {
			...state,
			imageUrlArr:payload.imageUrlObj ? [...state.imageUrlArr, payload.imageUrlObj] : [...payload.imageUrlArr]
		}
	} else{
		const newImageUrlArr = [...state.imageUrlArr] || [];
		const imageIndex = payload.updateDefaultIndex
			? payload.updateDefaultIndex
			: getUploadKeyIndex(newImageUrlArr, payload.imgIndex);
		if (payload.createdfrom == "photoGallery") {
			payload.imageUrlArr.map(item => {
				newImageUrlArr.push({ ...item, imgURL: item.imageUrl });
			})
		} else {
			if (imageIndex != -1) {
				newImageUrlArr[imageIndex] =
					payload.initialReq && payload.updateDefaultIndex
						? {
							...payload.imageUrl
						}
						: {
							...newImageUrlArr[imageIndex],
							...payload.imageUrl
						};
			} else {
				newImageUrlArr.push(payload.imageUrl);
			}
		}
		return {
			...state,
			imageUrlArr: newImageUrlArr
		};
	}
} else {
		let videourlId = null;
		if(payload?.imageUrl?.source === 'YOUTUBE' && payload?.imageUrl?.status === 'UNDER_REVIEW'){
			videourlId = payload.imageUrl.videoId;
		}
		let newVideoUrlIds = state.videoUrlIds ? [...state.videoUrlIds]: [];
		const tempVideoId = payload.imgIndex || payload.videoId || videourlId;
		if (payload.updateVideoId) {
			newVideoUrlIds = newVideoUrlIds.map((curId, index) => {
				if (curId === payload.videoId) {
					curId = payload.newVideoId
				}
				return curId
			})
			if (!newVideoUrlIds.length) {
				newVideoUrlIds = [payload.newVideoId]
			}
		} else if (newVideoUrlIds.indexOf(tempVideoId) === -1) {
			newVideoUrlIds = [tempVideoId];
		}
	return {
		...state,
		videoUrlIds: newVideoUrlIds,
		videoUrlArr: getVideoUrlArr(newVideoUrlIds, PState)
	};
}
}

export const toggleBrochurehistorySlider = (payload) => ({
	type: TOGGLE_BROCHURE_UPLOADHISTORY_SLIDER,
	payload
});

export const toggleBrochureNameDialog = (payload) => ({
	type: TOGGLE_BROCHURE_EDITNAME_DIALOG,
	payload
});

export const toggleBrochurefilePreview = (payload) => ({
	type: TOGGLE_BROCHURE_EDITNAME_DIALOG,
	payload
});

export const renameBrochureName = (payload) => async (
	dispatch,getState
) => {
	const session = getState().session;
	axios.get('/marketplace/static/php/web/b2bBrochure.php?action=updateBrochureName&fileId='+payload.fileId+'&fileName='+payload.fileName+'&token='+session.token).then(res => {
		if(res.data.status) {
			dispatch(getListingData({tabKey: 'brochure'}))
		}
	})

};

export const deleteBrochure = (payload) => async (
	dispatch,getState
) => {
	const { session: { docId, user : { loggedUser : { userType, userName } },hasGlassFooter }, products: { brochureAttachment : { fileAttachments } } } = getState();
	dispatch(showHideLoader({ showLoader: true }));
	const { showMessage } = await import('jd-library/src/Toast/ToastAction');
	const data = {
		docid: docId,
		bid: payload?.brochureId
	}
	await axios.post('/marketplace/dc-brochures/deleteFile.ns?usertype='+userType, data, {
		headers: {
			'mobileNo': userName
		}
	});
		dispatch(activateBrochureTab());
		dispatch(getListingData({ tabKey: 'brochure',
		cb: (list) =>  {
			if(list){
				dispatch(showHideLoader({ showLoader: false }))
				dispatch(showMessage({ 
					showToastMessage: true,
					message: 'File Deleted',
					type: 'info',
					duration: 5000,
					bottom: hasGlassFooter ? '80px' : '0px'
				 }))
			}
	 	}}));
};

export const setBrochureData = (payload) => async (
	dispatch,getState
) => {
	const state = getState();
	let formData = new FormData;
	const dataToSend = [{
		fileId: payload.data.id,
		fileName: payload.data.fileName,
		fileExt: payload.data.ext,
	}]
	formData.append('brochureJson',JSON.stringify(dataToSend));
	formData.append('token',state.session.token);
	console.log(dataToSend);
	if(payload.uploading){
		axios.post('/marketplace/static/php/web/b2bBrochure.php?action=addBrochure',
		formData).then(res => {
			if(res.data.status == 1){
				dispatch({
					type: SET_BROCHURE_DATA,
					payload
				})
			}
		})
	}else {
		dispatch({
			type: SET_BROCHURE_DATA,
			payload
		})
	}
}

export const addTotalFilesToBrochure = (payload) => ({
	type: BROCHURE_TOTAL_FILES_UPLOAD,
	payload
});

export const addErrorFilesToBrochure = (payload) => ({
	type: BROCHURE_TOTAL_FILES_ERROR,
	payload
})

export const addSuccessFilesToBrochure = (payload) => ({
	type: BROCHURE_SUCCESS_FILE_UPLOAD,
	payload
})

export const resetBrochureFileHistory = () => ({
	type: BROCHURE_FILES_RESET_DATA
})

export const activateBrochureTab = () => ({
	type: BROCHURE_TEMP_ACTIVE_TAB
})

export const toggleProductCardSlider = (payload) => ({
	type: TOGGLE_PRODUCT_CARD_SLIDER,
	payload
})

export const pricecardDataFetched = (payload) => ({
	type: PRICE_CARD_DATA_FETCHED,
	payload
})

export const toggleOutDatedProductCardSlider = (payload) => ({
	type: TOGGLE_OUTDATED_PRODUCT_CARD_SLIDER,
	payload
})

export const outDatedPricecardDataFetched = (payload) => ({
	type: OUTDATED_PRICE_CARD_DATA_FETCHED,
	payload
})

export const clickTrack = (payload) => async (
	dispatch,getState
) => {
	const state = getState();
	if(payload.userBasedCheck){
		let suffix = '';
		if(state.session?.user?.loggedUser?.subType == 'CONTRACTOR'){
			suffix = 'conv1';
		}else if(state.session?.user?.loggedUser?.subType == 'CONTRACTORV2'){
			suffix = 'conv2';
		}else if(state.session?.user?.loggedUser?.userType == 'OWNER'){
			suffix = 'owner';
		}else if(state.session?.user?.loggedUser?.userType == 'JDEMPLOYEE'){
			suffix = 'obe';
		}
		payload.li = suffix && payload.li ? payload.li+'_'+suffix : payload.li;
	}
	var deviceSource = state.session.userSource || getDeviceType();
	axios.get(`/marketplace/webstore/collect-data.ns?li=${payload.li}&ll=${payload.ll}&device_src=${deviceSource}&device_id=Omni_Marketplace&doc_id=${state.session.docId}`).then(res => {
		if(res.data.isSuccess)
			console.log('Click tracked successfully')
	}).catch(err => {
		console.log('Error in ClickTracker => ',err)
	})
}

export const toggleCategoryMissingCardSlider = (payload) => ({
	type: TOGGLE_CATEGORY_MISSING_CARD_SLIDER,
	payload
})

export const categoryMissingDataFetched = (payload) => ({
	type: CATEGORY_MISSING_DATA_FETCHED,
	payload
})

export const toggleCategoryMissingCardSliderPersist = (payload) => ({
	type: TOGGLE_CATEGORY_MISSING_CARD_SLIDER_PERSIST,
	payload
})


export const deleteVideoUrlIdsFromAllProducts = (payload) => ({
	type: DELETE_VIDEO_URL_ID_ALL_PRODUCTS,
	payload
})

export const updateDescType = (payload) => ({
	type: UPDATE_DESC_TYPE,
	payload
})

export const addJdGalleryPhotos = (payload) => async (dispatch,getState) => {
	const{
		cb,
		token,
		source,
		productId,
		curImageUrl = "",
		vendorImages = [],
		selectedImages = [],
		fromListing = false,
		isAddEditProduct,
		isAddEditProductOmni
	} = payload;
		const imageArr = vendorImages.filter((cur, index)=>selectedImages.includes(index));
		let finalImageUrl = imageArr.filter((cur) => {
			return cur.uploaded
		})
		finalImageUrl = finalImageUrl.map(obj => obj.imageUrl);
		let combinedUrl = '';
		if(curImageUrl){
			combinedUrl = curImageUrl + "," + finalImageUrl.join(",");
		}else{
			combinedUrl = finalImageUrl.join(",");
		}
		if(combinedUrl.split(",").length > 40) {
			return cb('maxImageToast');
		}
		if(isAddEditProduct || isAddEditProductOmni){
			const uploadPromises = finalImageUrl
				.filter(curLink => curLink.includes('content.jdmagicbox'))
				.map(curLink =>
				new Promise(resolve => {
					dispatch(uploadImageFromLink({
						link: curLink,
						isAddProductPage: isAddEditProduct,
						isAddProductPageOmni: isAddEditProductOmni,
					}, isSuccess => resolve(isSuccess)));
				})
			);
			Promise.all(uploadPromises).then(results => {
				cb('successToast');
			})
		} else {
			combinedUrl = '';
			const uploadPromises = finalImageUrl
				.filter(curLink => curLink.includes('content.jdmagicbox'))
				.map(curLink =>
				new Promise(resolve => {
					dispatch(uploadImageFromLink({
					link: curLink,
					isAddProductPage: isAddEditProduct,
					isAddProductPageOmni: isAddEditProductOmni,
					}, isSuccess => resolve(isSuccess)));
				})
			);
			Promise.all(uploadPromises).then(results => {
				const state = getState();
				state.products.allProducts[productId].imageUrlArr.forEach(cur => {
				combinedUrl += cur.imgURL + ',';
			});

			updateProductMediaService({
				productId,
				imageUrl: combinedUrl.substring(0, combinedUrl.length - 1),
				token,
				source,
				fromListing
			}).then(() => {
				const imageUrlArr = combinedUrl.split(",").map(cur => ({
					imgURL: cur,
					actualPath: getImagePath(cur),
					uploaded: true
				}));
				cb('successToast', imageUrlArr);
			});
		});
	}
}

export const handleAIProductCreation = (payload) => async (dispatch,getState) => {
	const { showMessage } = await import('jd-library/src/Toast/ToastAction');
	let jdMartParams = getJdMartParams();
	let url = '/vendorapis/products/ai_catalogue/aiProductRequest';
	const formData = new FormData();
	formData.append('source', payload.fromPhotoSlider ? 'product' : 'broucher');
	formData.append('medialink', payload.imageArr.map(cur => cur.imageUrl).join(','));
	formData.append('token', getState().session.token);
	!payload.fromPhotoSlider && formData.append('broucher_id',payload.imageArr.map(cur => cur.id).join(','));
	formData.append('sourceId', jdMartParams.sourceId ? jdMartParams.sourceId : '');
	Axios.post(url, formData).then(async res => {
		if(res.data.status) {
			setTimeout(() => {
				dispatch(toggleAICreationModal({ successModal: {show: true} }));
			}, 500);
		} else {
			dispatch(showMessage({
				showToastMessage: true,
				message: res.data?.errors?.msg || 'We could not identify products from the uploaded files. Please try again with clearer content.',
				type: 'error',
				duration: 5000,
			}));
		}
	})
}

export const toggleAICreationModal = (payload) => ({
	type: TOGGLE_AI_CREATION_MODAL,
	payload
})
